import React from "react";
import {
  Button,
  Col,
  FormLabel,
  Row,
  Table,
  FormControl,
} from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { NEW_ENTRY } from "../ds/App_Constants.js";
import { BaseBean, NodeData, RestReportBean } from "../ds/client_ds.js";
import {
  AddressBean,
  InvoiceServiceLineBean,
  PageListBean,
  PurchaseOrderBean,
  PurchaseOrderInTransitBean,
  PurchaseOrderInTransitForPurchaseOrderSearchCriteria,
  PurchaseOrderInTransitSearchCriteria,
  PurchaseOrderReceiptBean,
  PurchaseOrderReceiptElectronicInputBean,
  PurchaseOrderReceiptLineBean,
  PurchaseOrderReceiptLineSearchCriteria,
  PurchaseOrderReceiptPrintRequest,
  PurchaseOrderReceiptRollLineBean,
  PurchaseOrderReceiptSearchCriteria,
  PurchaseOrderSearchCriteria,
  PurchaseReceiptToInvoiceInputBean,
  ReasonBean,
  RestEntityUnLockRequest,
  RestPurchaseOrderInTransitListRequest,
  RestPurchaseOrderListRequest,
  RestPurchaseOrderReceiptBeanRequest,
  RestPurchaseOrderReceiptExcelImportRequest,
  RestPurchaseOrderReceiptLineRequest,
  RestPurchaseOrderReceiptListRequest,
  RestPurchaseOrderReceiptRequest,
  RestReadRequest,
  VendorBean,
} from "../ds/ds.js";
import { LogicConstants } from "../ds/LogicConstants.js";
import { DeleteIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  ColumnDefinition,
  DataGrid,
  DataGridColumnDefinition,
  DatePickerComponent,
  InputTextbox,
  MultiViewPopup,
  NumberFormatInputbox,
  ProgressBar,
  ReasonCaptureComponent,
  ShortCutMenuPopup,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { PurchaseOrderInTransitLookupHandler } from "../lookup/PurchaseOrderInTransitLookupHandler.js";
import { PurchaseOrderLookupHandler } from "../lookup/PurchaseOrderLookupHandler.js";
import { PurchaseOrderReceiptLookupHandler } from "../lookup/PurchaseOrderReceiptLookupHandler.js";
import {
  PopupPurchaseInTransitModule,
  PopupPurchaseOrderModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { PurchaseOrderInTransitService } from "../services/PurchaseOrderInTransitService.js";
import { PurchaseOrderReceiptService } from "../services/PurchaseOrderReceiptService.js";
import { PurchaseOrderService } from "../services/PurchaseOrderService.js";
import { ReportService } from "../services/ReportService.js";
import { BaseNodeBar, BaseToolBar, ModuleToolBar } from "./BaseModule.js";
import { ModuleUtils } from "./ModuleUtils.js";
import CustomTable from "../gui_components/CustomTable.js";
class PurchaseOrderReceiptList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.cancelReasonDialogRef = React.createRef();
    this.receiptLineCancelReasonDialogRef = React.createRef();
    this.rollLineCancelReasonDialogRef = React.createRef();
    this.state = {
      pageTitle: "Purchase Order Receipt Maintenance",
      purchaseOrderReceiptListData: new Array(),
      pageList: new PageListBean(),
      criteria: new PurchaseOrderReceiptSearchCriteria(),
      purchaseOrderReceiptData: new PurchaseOrderReceiptBean(),
      purchaseOrderReceiptLineData: new PurchaseOrderReceiptLineBean(),
      purchaseOrderReceiptRollLineData: new PurchaseOrderReceiptRollLineBean(),
      purchaseOrdersList: new Array(),
      purchaseOrderData: new PurchaseOrderBean(),
      currentVendor: new VendorBean(),
      purchaseOrderReceiptElectronicInputBean:
        new PurchaseOrderReceiptElectronicInputBean(),
      purchaseOrderInTransitListData: new Array(),
      purchaseOrderInTransitData: new PurchaseOrderInTransitBean(),
      currentPageNumber: 0,
      totalCount: 0,
      error_list: [],
      nodeList: [],
      purchaseRollList: [],
      vendor_List: new Array(),
      fabricStyle_List: new Array(),
      fOBCities: new Array(),
      shipmentTerms: new Array(),
      wareHouses: new Array(),
      incoTerms: new Array(),
      paymentTerms: new Array(),
      vendorTerms: new Array(),
      transportTypes: new Array(),
      countries: new Array(),
      uoms: new Array(),
      shipVias: new Array(),
      isLoading: true,
      isDisableFields: false,
      isShowNodes: false,
      isShowNewButton: true,
      isShowBackButton: false,
      isShowSaveButton: false,
      isShowClearErrorButton: false,
      isShowPDFReportButton: false,
      isShowExcelButton: false,
      isShowUnApproveButton: false,
      isShowApproveButton: false,
      isShowCancelButton: false,
      isShowCreateInvoiceButton: false,
      isPurchaseOrderReceiptListFormOpen: true,
      isPurchaseOrderReceiptEntryFormOpen: false,
      isPurchaseOrderReceiptHistoryFormOpen: false,
      selectedNodeKey: "headerView",
      selectedDocument: "",
      reasonData: new ReasonBean(),
      cancelReasons: [],
      unapprovalReasons: [],
      isResetModule: false,
      moduleForPopup: [],
      isShowPopup: false,
      simplePopupContent: [],
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isReadOnlyOrDisabled: false,
      isSpecialViewMode: false,
      purchaseOrderReceiptLookupHandler: null,
      isShowModuleSearchContainer: false,
      moduleKeyCode: NEW_ENTRY,
      isResetModule: false,
      moduleOrderStatus: "",
      disableFormFields: false,
      disabled: false,
      isResetView: true,
      isFocus: false,
      isFocusLookup: true,
      poReceiptRollLinesList: new Array(),
      isMaintenanceMode: true,
      isDisabledFields: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isDisableRollLine: false,
      isShowPopupAlert: false,
      isShowLinePopup: false,
      isShowPurchaseOrderModule: false,
      isShowPurchaseOrderInTransitModule: false,
      fabricStyles: [],
      purchaseOrderBean: new PurchaseOrderBean(),
      isShowPopupAlertlvl1: false,
      isShowPopupAlertlvl5: false,
      isShowPORButton: true,
      isShowAutoCompletePurchaseOrderList: false,
      purchaseOrderPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteRolllineLocationList: false,
      rollLineLocationPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteLocationList: false,
      locationPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteFobCityList: false,
      FobCityPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteShipmentTermList: false,
      shipmentTermPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteShipViaList: false,
      shipViaPageListForAutoCompleteList: new Array(),
      isShowAutoCompletePoIntransitList: false,
      poIntransitPageListForAutoCompleteList: new Array(),
      isDisableButtons: true,
      reasonPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteReason: false,
      is3PL: false,
      isShowCreateInvoicePopup: false,
      isShowPopupAlertlvl2: false,
      invoiceServiceLineList: [],
      services: [],
      invoiceServiceLineData: new InvoiceServiceLineBean(),
      isShowAutoCompleteInvoiceUomList: false,
      invoiceUomPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteServiceList: false,
      servicePageListForAutoCompleteList: new Array(),
      isShowInTransitLookup: true,
      isDisablePoIntransit: false,
      isShowCancelReasonPopup: false,
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      isShowLineCancelReasonPopup: false,
      isShowRollLineCancelReasonPopup: false,
      order: "",
      sortField: "",
      isReseted: false,
      isViewMode: false,
    };
  }
  code = NEW_ENTRY;
  isLocked = false;
  moduleCaption = "Purchase Order Receipt Maintenance";
  fetchAttributesFromLocalStorage = () => {
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    const attribute_cache = { ...this.cache };
    let fOBCities = attribute_cache.fOBCities;
    if (fOBCities != null || fOBCities != undefined) {
      fOBCities.map((attr) => {
        this.state.fOBCities.push(attr);
      });
    }
    let shipmentTerms = attribute_cache.shipmentTerms;
    if (shipmentTerms != null || shipmentTerms != undefined) {
      shipmentTerms.map((attr) => {
        this.state.shipmentTerms.push(attr);
      });
    }
    let wareHouses = attribute_cache.warehouses;
    if (wareHouses != null || wareHouses != undefined) {
      wareHouses.map((attr) => {
        this.state.wareHouses.push(attr);
      });
    }
    let incoTerms = attribute_cache.incoTerms;
    if (incoTerms != null || incoTerms != undefined) {
      incoTerms.map((attr) => {
        this.state.incoTerms.push(attr);
      });
    }
    let paymentTerms = attribute_cache.paymentTerms;
    if (paymentTerms != null || paymentTerms != undefined) {
      paymentTerms.map((attr) => {
        this.state.paymentTerms.push(attr);
      });
    }
    let transportTypes = attribute_cache.transportTypes;
    if (transportTypes != null || transportTypes != undefined) {
      transportTypes.map((attr) => {
        this.state.transportTypes.push(attr);
      });
    }
    let countries = attribute_cache.countries;
    if (countries != null || countries != undefined) {
      countries.map((attr) => {
        this.state.countries.push(attr);
      });
    }
    let uoms = attribute_cache.uoms;
    if (uoms != null || uoms != undefined) {
      uoms.map((attr) => {
        this.state.uoms.push(attr);
      });
    }
    let vendorTerms = attribute_cache.vendorTerms;
    if (vendorTerms != null || vendorTerms != undefined) {
      vendorTerms.map((attr) => {
        this.state.vendorTerms.push(attr);
      });
    }
    let shipVias = attribute_cache.vendorShipVias;
    if (shipVias != null || shipVias != undefined) {
      shipVias.map((attr) => {
        this.state.shipVias.push(attr);
      });
    }
    this.state.cancelReasons = [];
    let cancelReasons = attribute_cache.purchaseReceiptCancelReasons;
    cancelReasons.map((ent) => {
      this.state.cancelReasons.push(ent);
    });
    let services = attribute_cache.serviceInfos;
    if (services != null || services != undefined) {
      services.map((attr) => {
        this.state.services.push(attr);
      });
    }
  };
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    const { cache } = appData;
    this.cache = cache;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.setState({
        is3PL: true,
      });
    }
    ModuleUtils.getPurchaseOrderReceiptStatusList();
    ModuleUtils.getPurchaseOrderReceiptLineStatusList();
    this.fetchAttributesFromLocalStorage();
    this.state.criteria = new PurchaseOrderReceiptSearchCriteria();
    this.state.criteria.companyCode = this.companyCode;
    this.state.pageList = new PageListBean();
    this.state.pageList.pageSize = 50;
    // this.getPurchaseOrdersList();
    this.initLookupHandlers();
    //set readOnly components using view Modes && disable toolbars
    let isReadOnly = this.state.isReadOnlyOrDisabled;
    let isSpecialViewMode = this.state.isSpecialViewMode;
    if (this.props.isSpecialViewMode) {
      isSpecialViewMode = this.props.isSpecialViewMode;
      isReadOnly = this.props.isSpecialViewMode;
    }
    this.setState({
      isReadOnlyOrDisabled: isReadOnly,
      isSpecialViewMode: isSpecialViewMode,
    });
    if (this.props.code !== "" && this.props.code !== undefined) {
      // this.unlockPurchaseOrderReceipt(this.props.code);
      this.code = this.props.code;
      this.editPurchaseOrderReceipt(this.props.code, false);
      this.setState({
        isResetView: false,
        isMaintenanceMode: false,
        isDisabledFields: true,
        disableFormFields: true,
        isViewMode: true,
      });
    } else {
      this.addNewEntry();
    }
  }
  initLookupHandlers = () => {
    let purchaseOrderReceiptLookupHandler =
      new PurchaseOrderReceiptLookupHandler(
        this.companyCode,
        "PurchaseOrder Receipt"
      );
    this.setState({
      purchaseOrderReceiptLookupHandler: purchaseOrderReceiptLookupHandler,
    });
    let serviceLookupHandler = new GenericAttributeLookupHandler(
      this.state.services,
      "Service"
    );
    this.setState({ serviceLookupHandler: serviceLookupHandler });
    let uomLookupHandler = new GenericAttributeLookupHandler(
      this.state.uoms,
      "UOM"
    );
    this.setState({ uomLookupHandler: uomLookupHandler });
    let purchaseInTransitLookupHandler =
      new PurchaseOrderInTransitLookupHandler(
        this.companyCode,
        "Purchase InTransit"
      );
    this.setState({
      purchaseInTransitLookupHandler: purchaseInTransitLookupHandler,
    });
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = this.state.error_list;
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  handleResponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  loadPage = (pageNumber) => {
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;

    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadPurchaseOrderReceiptPage();
  };
  onCriteriaChange = (e) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  resetfilteredPurchaseOrder = (criteria) => {
    criteria = new PurchaseOrderReceiptSearchCriteria();
    criteria.companyCode = this.companyCode;
    this.state.criteria = criteria;
    this.setState({ criteria: criteria });
    this.loadPage(1);
    criteria.criteriakey = "";
  };
  filterPurchaseOrder = () => {
    this.loadPage(1);
  };
  loadPurchaseOrderReceiptPage = () => {
    let requestInput = new RestPurchaseOrderReceiptListRequest();
    requestInput.pageInput = this.state.pageList;
    requestInput.searchCriteria = this.state.criteria;
    this.setState({
      isLoading: true,
      loadingText: "Loading ..",
    });
    if (
      SecurityAccessManager.PurchaseOrderReceiptMaintenanceView_IsAccessible()
    ) {
      PurchaseOrderReceiptService.getPurchaseOrderReceiptPageList(
        requestInput,
        this.loadPurchaseOrderReceiptResponse,
        this.loadPurchaseOrderReceiptError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadPurchaseOrderReceiptResponse = (response) => {
    if (
      response.data != null &&
      response.data.purchaseOrderReceiptPageList != null
    ) {
      if (
        !isEmptyArray(
          response.data.purchaseOrderReceiptPageList.purchaseOrderReceipts
        )
      ) {
        let pageList = this.state.pageList;

        let purchaseOrderReceiptListData =
          response.data.purchaseOrderReceiptPageList.purchaseOrderReceipts;
        pageList.totalCount =
          response.data.purchaseOrderReceiptPageList.totalCount;
        pageList.currentPage =
          response.data.purchaseOrderReceiptPageList.currentPage;
        this.setState({
          isLoading: false,
          purchaseOrderReceiptListData: purchaseOrderReceiptListData,
          pageList: pageList,
        });
      }
    }
    this.setState({
      isLoading: false,
      loadingText: "",
    });
  };
  loadPurchaseOrderReceiptError = (error) => {
    ShowError("Error :" + error);
    this.setState({
      isLoading: false,
      loadingText: "",
    });
  };
  unlockPurchaseOrderReceipt = (code) => {
    let request = new RestEntityUnLockRequest();
    request.companyCode = this.companyCode;
    request.entityCode = code;
    if (SecurityAccessManager.PurchaseOrderReceiptMaintenance_IsAccessible()) {
      PurchaseOrderReceiptService.unLockPurchaseOrderReceipt(
        request,
        this.unlockPurchaseOrderReceiptResponse,
        this.unlockPurchaseOrderReceiptError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  unlockPurchaseOrderReceiptResponse = (response) => {
    if (!isEmpty(response.data)) {
      if (response.data.isSuccess) {
        if (this.isLocked) {
          this.editPurchaseOrderReceipt(this.code);
        } else {
          this.isLocked = false;
        }
      } else {
        // this.isLocked = false; optional
        if (!this.state.isReseted) this.showErrorMessage(response.data);
      }
    }
  };
  unlockPurchaseOrderReceiptError = (error) => {
    ShowError("Error : ", error);
  };

  getPurchaseOrdersList = () => {
    this.loadPurchaseOrderList();
  };
  loadPurchaseOrderList = () => {
    let criteria = new PurchaseOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    let orderStatusList = new Array();
    orderStatusList.push("A");
    orderStatusList.push("I");
    criteria.orderStatusList = orderStatusList;
    let requestInput = new RestPurchaseOrderListRequest();
    requestInput.pageInput = this.state.pageList;
    requestInput.searchCriteria = criteria;
    this.setState({
      isLoading: true,
      loadingText: "Loading ..",
    });
    if (SecurityAccessManager.PurchaseOrderReceiptMaintenance_IsAccessible()) {
      PurchaseOrderService.getPurchaseOrderPageList(
        requestInput,
        this.loadPurchaseOrderResponse,
        this.loadPurchaseOrderError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadPurchaseOrderResponse = (response) => {
    if (response.data != null && response.data.purchaseOrderPageList != null) {
      let purchaseOrdersList =
        response.data.purchaseOrderPageList.purchaseOrders;
      if (!isEmptyArray(purchaseOrdersList == null)) {
        purchaseOrdersList = new Array();
      }
      this.setState({ purchaseOrdersList: purchaseOrdersList });
    }
  };
  loadPurchaseOrderError = (error) => {
    ShowError("Error : ", error);
  };
  displayAutoCompletePurchaseOrderList = (showAutoCompleteList) => {
    this.setState({
      isShowAutoCompletePurchaseOrderList: showAutoCompleteList,
    });
  };
  readPurchaseOrder = (purchaseOrderCode) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading Fields ..",
    });
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = purchaseOrderCode;
    if (SecurityAccessManager.PurchaseOrderReceiptMaintenance_IsAccessible()) {
      PurchaseOrderService.readPurchaseOrder(
        readrestInput,
        this.readPurchaseOrderResponse,
        this.readPurchaseOrderError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  readPurchaseOrderResponse = (response) => {
    if (response.data != null && response.data.purchaseOrder != null) {
      let pageTitle = this.moduleCaption + " - EDIT";
      this.setState({
        purchaseOrderData: response.data.purchaseOrder,
      });
      this.readPOIntransit(response.data.purchaseOrder.code);
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readPurchaseOrderError = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error : ", error);
  };
  readPOIntransit = (code) => {
    let request = new PurchaseOrderInTransitForPurchaseOrderSearchCriteria();
    request.companyCode = this.companyCode;
    request.purchaseOrderNumber = code;
    PurchaseOrderInTransitService.getPurchaseOrderInTransitForPurchaseOrder(
      request,
      this.poIntransitResponse,
      this.errorCallBack
    );
  };
  poIntransitResponse = (response) => {
    const poData = this.state.purchaseOrderData;
    if (
      response.data != null &&
      response.data.result != null &&
      !isEmptyArray(response.data.result.purchaseOrderInTransits)
    ) {
      const purchaseOrderInTransits =
        response.data.result.purchaseOrderInTransits;
      if (purchaseOrderInTransits.length === 1) {
        this.toUpdatePurchaseOrderInTransitData(purchaseOrderInTransits[0]);
        this.setState({
          isDisablePoIntransit: true,
        });
      } else if (purchaseOrderInTransits.length > 1) {
        // lookup call based on po
        let purchaseInTransitLookupHandler =
          new PurchaseOrderInTransitLookupHandler(
            this.companyCode,
            "Purchase InTransit",
            poData.code,
            LogicConstants.PURCHASEORDER_INTRANSIT_APPROVE_STATUS
          );
        this.setState({
          purchaseInTransitLookupHandler: purchaseInTransitLookupHandler,
        });
        this.setState({
          isShowInTransitLookup: true,
        });
      }
    } else {
      this.toUpdatePurchaseOrderData();
    }
  };
  errorCallBack = (error) => {
    ShowError("Error : ", error);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: " ",
    });
  };
  readPOIntransitBySearchString = (poIntransitNumber) => {
    let inTransitCriteria = new PurchaseOrderInTransitSearchCriteria();
    inTransitCriteria.companyCode = this.companyCode;
    inTransitCriteria.purchaseOrderInTransitNumberStartsWith =
      poIntransitNumber;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = 1;
    let requestInput = new RestPurchaseOrderInTransitListRequest();
    requestInput.pageInput = pageInput;
    requestInput.searchCriteria = inTransitCriteria;
    if (SecurityAccessManager.PurchaseOrderReceiptMaintenance_IsAccessible()) {
      PurchaseOrderInTransitService.getPurchaseOrderInTransitPageList(
        requestInput,
        this.loadPurchaseOrderInTransitResponse,
        this.loadPurchaseOrderInTransitError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadPurchaseOrderInTransitResponse = (response) => {
    if (response.data != null && response.data.inTransitPageListBean != null) {
      if (response.data.inTransitPageListBean.purchaseOrderinTransits != null) {
        let purchaseOrderInTransitListData =
          response.data.inTransitPageListBean.purchaseOrderinTransits;
        let simpleAutoCompleteList = new Array();
        if (
          purchaseOrderInTransitListData.length > 0 &&
          purchaseOrderInTransitListData != null
        ) {
          purchaseOrderInTransitListData.map((obj) => {
            let simpleItemBean = {
              code: obj.code,
              description: "",
            };
            simpleAutoCompleteList.push(simpleItemBean);
          });
        }
        this.setState({
          poIntransitPageListForAutoCompleteList: simpleAutoCompleteList,
        });
      }
    }
  };
  loadPurchaseOrderInTransitError = (error) => {
    ShowError("Error :" + error);
  };
  readPurchaseInTransit = (purchaseInTransitCode) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading Fields ..",
    });
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = purchaseInTransitCode;
    if (SecurityAccessManager.PurchaseOrderReceiptMaintenance_IsAccessible()) {
      PurchaseOrderInTransitService.readPurchaseOrderInTransit(
        readrestInput,
        this.readPurchaseOrderInTransitResponse,
        this.readPurchaseOrderInTransitError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readPurchaseOrderInTransitResponse = (response) => {
    if (response.data.purchaseOrderinTransit != null) {
      let ptBean = response.data.purchaseOrderinTransit;
      if (ptBean != null) {
        this.setState({
          purchaseOrderInTransitData: ptBean,
        });
        this.toUpdatePurchaseOrderInTransitData(ptBean);
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readPurchaseOrderInTransitError = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error : ", error);
  };
  getPurchaseOrderLineMaxLineNumber = (purchaseOrderReceiptData) => {
    let maxLineNumber = 1;
    let poLineData = purchaseOrderReceiptData.lines;
    if (poLineData.length > 0)
      poLineData.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    return maxLineNumber;
  };
  toUpdatePurchaseOrderData = () => {
    const purchaseOrderData = { ...this.state.purchaseOrderData };
    let purchaseOrderReceiptData = { ...this.state.purchaseOrderReceiptData };
    if (!isEmpty(purchaseOrderData)) {
      purchaseOrderReceiptData.factoryCode = purchaseOrderData.factoryCode;
      purchaseOrderReceiptData.receiptDate = new Date();
      purchaseOrderReceiptData.createdDate = new Date();
      purchaseOrderReceiptData.companyCode = this.companyCode;
      purchaseOrderReceiptData.purchaseOrderNumber = purchaseOrderData.code;
      purchaseOrderReceiptData.vendorCode = purchaseOrderData.vendorCode;
      purchaseOrderReceiptData.vendorName = purchaseOrderData.vendorName;
      purchaseOrderReceiptData.factoryCode = purchaseOrderData.factoryCode;
      purchaseOrderReceiptData.fOBCity = purchaseOrderData.fOBCity;
      purchaseOrderReceiptData.shipViaCode = purchaseOrderData.shipViaCode;
      purchaseOrderReceiptData.shipmentTermsCode =
        purchaseOrderData.shipmentTermsCode;
      purchaseOrderReceiptData.locationCode = purchaseOrderData.locationCode;
      purchaseOrderReceiptData.customerCode = purchaseOrderData.customerCode;
      purchaseOrderReceiptData.customerReferenceNumber =
        purchaseOrderData.customerReferenceNumber;
      purchaseOrderReceiptData.containerNumber =
        purchaseOrderData.containerNumber;
      var lineNumber = this.getPurchaseOrderLineMaxLineNumber(
        purchaseOrderReceiptData
      );
      let receiptLines = new Array();
      if (purchaseOrderData.lines) {
        for (let line of purchaseOrderData.lines) {
          if (line.lineStatus == "O") {
            let receiptLine = new PurchaseOrderReceiptLineBean();
            receiptLine.companyCode = line.companyCode;
            receiptLine.lineStatus = "O";
            receiptLine.purchaseOrderNumber = line.purchaseOrderNumber;
            receiptLine.lineNumber = lineNumber;
            receiptLine.purchaseOrderLineNumber = line.lineNumber;
            receiptLine.fabricStyleCode = line.fabricStyleCode;
            receiptLine.fabricStyleName = line.fabricStyleName;
            receiptLine.widthCode = line.widthCode;
            receiptLine.colorCode = line.colorCode;
            receiptLine.skuNumber = line.skuNumber;
            receiptLine.upcCode = line.upcCode;
            receiptLine.uomCode = line.uomCode;
            receiptLine.inventoryUomCode = line.inventoryUomCode;
            receiptLine.uomConversionRate = line.uomConversionRate;
            receiptLine.locationCode = line.locationCode;
            receiptLine.vendorStyleCode = line.vendorStyleCode;
            receiptLine.vendorStyleColorCode = line.vendorStyleColorCode;
            receiptLine.purchaseOrderQuantity = line.orderQuantity;
            receiptLine.openOrderQuantity = line.orderQuantity;
            receiptLine.receivedQuantity = 0;
            receiptLine.receivedQuantityToDate = 0;
            receiptLine.badQualityReceivedQuantity = 0;
            receiptLine.goodQualityReceivedQuantity = 0;
            receiptLine.inTransitQuantity = line.inTransitQuantity;
            receiptLine.openInTransistQuantity = line.inTransitQuantity;
            ++lineNumber;
            receiptLines.push(receiptLine);
          }
        }
      }
      purchaseOrderReceiptData.lines = receiptLines;
      this.setState({
        purchaseOrderReceiptData: purchaseOrderReceiptData,
        isShowInTransitLookup: false,
      });
    }
  };
  toUpdatePurchaseOrderInTransitData = (purchaseIntransitData) => {
    let purchaseOrderReceiptData = { ...this.state.purchaseOrderReceiptData };
    let purchaseOrderData = { ...this.state.purchaseOrderData };
    let purchaseOrderReceiptLineData = this.state.purchaseOrderReceiptLineData;
    if (!isEmpty(purchaseIntransitData)) {
      purchaseOrderReceiptData.factoryCode = purchaseIntransitData.factoryCode;
      purchaseOrderReceiptData.receiptDate = new Date();
      purchaseOrderReceiptData.createdDate = new Date();
      purchaseOrderReceiptData.companyCode = this.companyCode;
      purchaseOrderReceiptData.purchaseOrderNumber =
        purchaseIntransitData.purchaseOrderNumber;
      purchaseOrderReceiptData.purchaseOrderInTransitNumber =
        purchaseIntransitData.code;
      purchaseOrderReceiptData.vendorCode = purchaseIntransitData.vendorCode;
      purchaseOrderReceiptData.vendorName = purchaseIntransitData.vendorName;
      purchaseOrderReceiptData.factoryCode = purchaseIntransitData.factoryCode;
      purchaseOrderReceiptData.fOBCity = purchaseIntransitData.fOBCity;
      purchaseOrderReceiptData.shipViaCode = purchaseIntransitData.shipViaCode;
      purchaseOrderReceiptData.shipmentTermsCode =
        purchaseIntransitData.shipmentTermsCode;
      purchaseOrderReceiptData.locationCode = purchaseOrderData.locationCode;
      var lineNumber = this.getPurchaseOrderLineMaxLineNumber(
        purchaseOrderReceiptData
      );
      let intransits = [];
      let receiptLines = new Array();
      if (purchaseIntransitData.lines) {
        for (let line of purchaseIntransitData.lines) {
          if (
            line.lineStatus ==
              LogicConstants.PURCHASE_ORDER_INTRANSIT_LINE_OPEN_STATUS &&
            line.inTransitQuantity != 0
          ) {
            let receiptLine = new PurchaseOrderReceiptLineBean();
            receiptLine.companyCode = line.companyCode;
            receiptLine.lineStatus =
              LogicConstants.PURCHASE_ORDER_INTRANSIT_LINE_OPEN_STATUS;
            receiptLine.purchaseOrderNumber = line.purchaseOrderNumber;
            receiptLine.lineNumber = lineNumber;
            receiptLine.purchaseOrderLineNumber = line.lineNumber;
            receiptLine.fabricStyleCode = line.fabricStyleCode;
            receiptLine.fabricStyleName = line.fabricStyleName;
            receiptLine.widthCode = line.widthCode;
            receiptLine.colorCode = line.colorCode;
            receiptLine.skuNumber = line.skuNumber;
            receiptLine.upcCode = line.upcCode;
            receiptLine.uomCode = line.uomCode;
            receiptLine.inventoryUomCode = line.inventoryUomCode;
            receiptLine.uomConversionRate = line.uomConversionRate;
            receiptLine.locationCode = purchaseOrderReceiptData.locationCode;
            receiptLine.vendorStyleCode = line.vendorStyleCode;
            receiptLine.vendorStyleColorCode = line.vendorStyleColorCode;
            receiptLine.purchaseOrderQuantity = line.purchaseOrderQuantity;
            receiptLine.openOrderQuantity = line.openOrderQuantity;
            receiptLine.receivedQuantity = line.inTransitQuantity;
            receiptLine.receivedQuantityToDate = 0;
            receiptLine.badQualityReceivedQuantity = 0;
            receiptLine.goodQualityReceivedQuantity = 0;
            receiptLine.inTransitQuantity = line.inTransitQuantity;
            receiptLine.openInTransistQuantity = line.inTransitQuantity;
            receiptLine.purchaseOrderInTransitLineNumber = line.lineNumber;
            receiptLine.purchaseOrderInTransitNumber =
              line.purchaseOrderInTransitNumber;
            // receiptLine.receiptRollLines = line.inTransitRollLines;
            let intransitRollLines = [];
            if (line.inTransitRollLines) {
              line.inTransitRollLines.map((rolls) => {
                let rollLine = new PurchaseOrderReceiptRollLineBean();
                rollLine.companyCode = rolls.companyCode;
                rollLine.purchaseOrderReceiptNumber =
                  purchaseOrderReceiptData.code;
                rollLine.receiptRollLineNumber = rolls.inTransitRollLineNumber;
                rollLine.receiptLineNumber = receiptLine.lineNumber;
                rollLine.rollSkuNumber = rolls.rollSkuNumber;
                rollLine.rollNumber = rolls.rollNumber;
                rollLine.locationCode = receiptLine.locationCode;
                rollLine.locationType = rolls.locationType;
                rollLine.fabricStyleCode = rolls.fabricStyleCode;
                rollLine.fabricStyleName = rolls.fabricStyleCode;
                rollLine.widthCode = rolls.widthCode;
                rollLine.uomCode = rolls.uomCode;
                rollLine.colorCode = rolls.colorCode;
                rollLine.skuNumber = rolls.skuNumber;
                rollLine.receivedQuantity = rolls.inTransitQuantity;
                rollLine.inventoryUomCode = rolls.inventoryUomCode;
                rollLine.uomConversionRate = rolls.uomConversionRate;
                rollLine.inventoryReceivedQuantity = 0;
                rollLine.boxNumber = rolls.boxNumber;
                rollLine.vendorLotNumber = rolls.vendorLotNumber;
                rollLine.infoText = rolls.infoText;
                rollLine.aisleInfoText = rolls.aisleInfoText;
                rollLine.inTransitQuantity = rolls.inTransitQuantity;
                rollLine.purchaseOrderInTransitLineNumber =
                  rolls.inTransitLineNumber;
                rollLine.purchaseOrderInTransitRollLineNumber =
                  rolls.inTransitRollLineNumber;
                intransitRollLines.push(rollLine);
              });
            }
            receiptLine.receiptRollLines = intransitRollLines;
            intransits = intransitRollLines;
            ++lineNumber;
            receiptLines.push(receiptLine);
          }
        }
      }
      purchaseOrderReceiptData.lines = receiptLines;
      purchaseOrderReceiptLineData.totalRolls = intransits.length;
      this.setState({
        purchaseOrderReceiptData: purchaseOrderReceiptData,
        purchaseOrderReceiptLineData: purchaseOrderReceiptLineData,
      });
    }
  };
  getEmptyView() {
    return <div></div>;
  }
  nodeOnSelect = (selectedNode) => {
    this.setState({ selectedNodeKey: selectedNode });
    if (selectedNode == "headerView") {
      this.setPurchaseReceiptHeaderView();
    } else if (selectedNode == "historyView") {
      this.setPurchaseReceiptHistoryView();
    }
  };
  getNodeList = () => {
    let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
    let nodeList = [];
    let headerObject = this.getEmptyView();
    let historyDetailObject = this.getEmptyView();
    let headerNode = new NodeData("headerView", "Header", headerObject);
    let historyDetailNode = new NodeData(
      "historyView",
      "History",
      historyDetailObject
    );
    nodeList["headerView"] = headerNode;
    if (purchaseOrderReceiptData.isFetched) {
      nodeList["historyView"] = historyDetailNode;
    }
    this.setState({ nodeList: nodeList });
  };
  setPurchaseReceiptHeaderView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowBackButton: true,
      isPurchaseOrderReceiptListFormOpen: false,
      isPurchaseOrderReceiptEntryFormOpen: true,
      isPurchaseOrderReceiptHistoryFormOpen: false,
    });
  };
  setPurchaseReceiptHistoryView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowBackButton: true,
      isPurchaseOrderReceiptListFormOpen: false,
      isPurchaseOrderReceiptEntryFormOpen: false,
      isPurchaseOrderReceiptHistoryFormOpen: true,
    });
  };
  closeAllNodeViews = () => {
    this.setState({
      isPurchaseOrderReceiptListFormOpen: false,
      isPurchaseOrderReceiptEntryFormOpen: false,
      isPurchaseOrderReceiptHistoryFormOpen: false,
    });
  };
  validatePOReceipt = (poReceiptBean) => {
    let isValidPoReceiptBean = false;
    let err_list = [];
    let errorMessage = "";
    if (poReceiptBean == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(poReceiptBean.lines)) {
        let errMsg = "PO Receipt Lines is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(poReceiptBean.purchaseOrderNumber)) {
        let errMsg = "PO Number is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(poReceiptBean.vendorCode)) {
        let errMsg = "Vendor Code is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(poReceiptBean.vendorName)) {
        let errMsg = "Vendor Name is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidPoReceiptBean = false;
      this.setState({ errorList: err_list });

      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
        isShowPopupAlert: false,
        isShowPopupAlertlvl1: false,
        isShowPopupAlertlvl5: false,
      });
    } else {
      isValidPoReceiptBean = true;
      this.setState({
        isShowAlert: false,
        isShowPopupAlert: false,
        isShowPopupAlertlvl1: false,
        isShowPopupAlertlvl5: false,
      });
    }
    return isValidPoReceiptBean;
  };
  save = () => {
    this.savePurchaseOrderReceipt();
  };
  savePurchaseOrderReceipt = () => {
    this.setState({
      isLoading: true,
      loadingText: "Saving ..",
    });
    let poReceiptBean = this.state.purchaseOrderReceiptData;
    let isValidLine = false;
    isValidLine = this.validatePOReceipt(poReceiptBean);
    if (isValidLine) {
      if (poReceiptBean.isFetched) {
        if (
          SecurityAccessManager.PurchaseOrderReceiptMaintenanceEdit_IsAccessible()
        ) {
          PurchaseOrderReceiptService.updatePurchaseOrderReceipt(
            poReceiptBean,
            this.savePurchaseOrderReceiptResponse,
            this.savePurchaseOrderReceiptError
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      } else {
        if (
          SecurityAccessManager.PurchaseOrderReceiptMaintenanceCreate_IsAccessible()
        ) {
          PurchaseOrderReceiptService.createPurchaseOrderReceipt(
            poReceiptBean,
            this.savePurchaseOrderReceiptResponse,
            this.savePurchaseOrderReceiptError
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);
          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
      // else {
      //   this.setState({
      //     isLoading: false,
      //     loadingText: "",
      //   });
      // }
    } else {
      this.setState({
        isLoading: false,
        loadingText: "",
      });
    }
  };
  savePurchaseOrderReceiptResponse = (response) => {
    this.handleResponse(response.data);
    if (response.data != null && !isEmpty(response.data.purchaseOrderReceipt)) {
      let purchaseOrderReceiptBean = response.data.purchaseOrderReceipt;
      let pageTitle = this.moduleCaption + " - EDIT";
      if (purchaseOrderReceiptBean != null) {
        this.setState({
          purchaseOrderReceiptData: purchaseOrderReceiptBean,
          pageTitle: pageTitle,
          isLoading: false,
          loadingText: "",
        });
        // this.unlockPurchaseOrderReceipt(purchaseOrderReceiptBean.code);
        // this.editPurchaseOrderReceipt(purchaseOrderReceiptBean.code, false);
        if (!this.isLocked) {
          this.editPurchaseOrderReceipt(purchaseOrderReceiptBean.code);
        } else {
          this.code = purchaseOrderReceiptBean.code;
          this.unlockPurchaseOrderReceipt(purchaseOrderReceiptBean.code);
        }
      }
    }
    this.setState({
      isLoading: false,
      loadingText: "",
    });
  };
  savePurchaseOrderReceiptError = (error) => {
    ShowError("Error : " + error);
  };
  back = () => {
    this.closeEntryForm();
    this.loadPage(1);
  };
  onChange = (e) => {
    let tempPurchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
    tempPurchaseOrderReceiptData[e.target.name] = e.target.value;
    this.setState({
      purchaseOrderReceiptData: tempPurchaseOrderReceiptData,
    });
  };
  onPurchaseOrderChange = (e) => {
    let purchaseOrderNumber = e.target.value;
    this.state.isShowAutoCompletePurchaseOrderList = true;
    let tempPurchaseReceiptData = this.state.purchaseOrderReceiptData;
    let showAutoCompleteList = this.state.isShowAutoCompletePurchaseOrderList;
    if (isEmpty(purchaseOrderNumber)) {
      this.state.isShowAutoCompletePurchaseOrderList = false;
      let showAutoCompleteList = this.state.isShowAutoCompletePurchaseOrderList;
      let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
      purchaseOrderReceiptData.purchaseOrderNumber = "";
      purchaseOrderReceiptData.vendorCode = "";
      purchaseOrderReceiptData.vendorName = "";
      purchaseOrderReceiptData.locationCode = "";
      purchaseOrderReceiptData.factoryCode = "";
      purchaseOrderReceiptData.shipmentTermsCode = "";
      purchaseOrderReceiptData.fOBCity = "";
      purchaseOrderReceiptData.lines = new Array();
      purchaseOrderReceiptData.shipViaCode = "";
      purchaseOrderReceiptData.purchaseOrderInTransitNumber = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        purchaseOrderReceiptData: purchaseOrderReceiptData,
        purchaseOrderPageListForAutoCompleteList: suggestion,
        isShowAutoCompletePoIntransitList: false,
        poIntransitPageListForAutoCompleteList: suggestion,
        isDisablePoIntransit: false,
        isShowInTransitLookup: true,
      });
    } else if (
      e.target.name == "purchaseOrderNumber" &&
      showAutoCompleteList === true &&
      purchaseOrderNumber !== ""
    ) {
      this.readPurchaseOrderBySearchString(e.target.value);
    }
    tempPurchaseReceiptData[e.target.name] = e.target.value;
    this.setState({ purchaseOrderReceiptData: tempPurchaseReceiptData });
  };
  readPurchaseOrderBySearchString(searchString) {
    let searchCriteria = new PurchaseOrderSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.purchaseOrderNumberStartsWith = searchString;
    searchCriteria.purchaseOrderNumberContains = searchString;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestPurchaseOrderListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    PurchaseOrderService.getPurchaseOrderPageList(
      cust_requestInput,
      this.readPurchaseOrderBySearchStringResponse,
      this.readPurchaseOrderBySearchStringError
    );
  }
  readPurchaseOrderBySearchStringResponse = (response) => {
    let purchaseorderData = response.data.purchaseOrderPageList.purchaseOrders;
    let simpleAutoCompleteList = new Array();
    if (response.data.purchaseOrderPageList != null) {
      if (purchaseorderData.length > 0 && purchaseorderData != null) {
        purchaseorderData.map((po) => {
          let simpleItemBean = {
            code: po.code,
            description: "",
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
    }
    this.setState({
      purchaseOrderPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  readPurchaseOrderBySearchStringError = (error) => {
    ShowError("Error : " + error);
  };
  purchaseOrderEnterKeyEventHandler = (e) => {
    let poCode = e.target.value;
    this.readPurchaseOrder(poCode);
    this.setState({
      purchaseOrderPageListForAutoCompleteList: new Array(),
    });
  };
  onDateChange = (e) => {
    let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
    purchaseOrderReceiptData[e.target.name] = e.target.value;
    this.setState({ purchaseOrderReceiptData: purchaseOrderReceiptData });
  };
  onVendorCodeChange = (e) => {
    let tempPurchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
    tempPurchaseOrderReceiptData[e.target.name] = e.target.value;
    let tempVendorData = this.state.currentVendor;
    if (e.target.name == "vendorCode") {
      tempPurchaseOrderReceiptData["vendorCode"] = e.target.value;
      let vendor_List = this.state.vendor_List;
      vendor_List.map((vendor) => {
        if (vendor.code == e.target.value) {
          tempPurchaseOrderReceiptData["vendorName"] = vendor.description;
          tempVendorData = vendor;
        }
      });
    }
    this.setState({
      purchaseOrderReceiptData: tempPurchaseOrderReceiptData,
      currentVendor: tempVendorData,
    });
  };
  closeEntryForm = () => {
    this.closeAllNodeViews();
    this.setState({
      isPurchaseOrderReceiptListFormOpen: true,
      isPurchaseOrderReceiptEntryFormOpen: false,
      isCollapsible_open: false,
      isShowSaveButton: false,
      isShowNewButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: false,
      isShowPDFReportButton: false,
      isShowApproveButton: false,
      isShowCancelButton: false,
      isShowCreateInvoiceButton: false,
      isShowNodes: false,
      isShowModuleSearchContainer: false,
      moduleKeyCode: NEW_ENTRY,
      disabled: false,
      isResetView: false,
      isMaintenanceMode: false,
      isShowExcelButton: false,
      isViewMode: false,
      isSpecialViewMode: false,
    });
  };
  openEntryForm = () => {
    this.closeAllNodeViews();
    this.getNodeList();
    this.setState({
      isPurchaseOrderReceiptListFormOpen: false,
      isPurchaseOrderReceiptEntryFormOpen: true,
      isCollapsible_open: false,
      isShowSaveButton: true,
      isShowNewButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowPDFReportButton: false,
      isShowExcelButton: false,
      isShowApproveButton: true,
      isShowCancelButton: false,
      isShowCreateInvoiceButton: false,
      isShowNodes: true,
      isShowModuleSearchContainer: true,
      isResetView: false,
      isShowPORButton: true,
      isShowAutoCompletePurchaseOrderList: false,
      purchaseOrderPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteRolllineLocationList: false,
      rollLineLocationPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteLocationList: false,
      locationPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteFobCityList: false,
      FobCityPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteShipmentTermList: false,
      shipmentTermPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteShipViaList: false,
      shipViaPageListForAutoCompleteList: new Array(),
      isShowAutoCompletePoIntransitList: false,
      poIntransitPageListForAutoCompleteList: new Array(),
      isDisableButtons: true,
      isShowInTransitLookup: true,
      isDisablePoIntransit: false,
    });
    if (this.state.isSpecialViewMode == false) {
      this.setState({
        isResetView: true,
        isMaintenanceMode: true,
        isPurchaseOrderReceiptListFormOpen: false,
        disabled: false,
        isDisableNodeFields: false,
        isDisabledFields: false,
        disableFormFields: false,
        isDisablePoIntransit: false,
      });
    } else {
      this.setState({
        isDisabledFields: true,
        disableFormFields: true,
        isDisablePoIntransit: true,
        disabled: true,
      });
    }
    if (this.state.moduleKeyCode != NEW_ENTRY) {
      this.setState({ disabled: true });
    }
    let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
    let moduleOrderStatus = this.state.moduleOrderStatus;
    let receiptStatus = ModuleUtils.getPurchaseOrderReceiptStatusCaption(
      this.state.purchaseOrderReceiptData.receiptStatus
    );
    if (receiptStatus !== undefined && receiptStatus !== null) {
      moduleOrderStatus = receiptStatus;
    }
    this.setState({ moduleOrderStatus: moduleOrderStatus });
    if (purchaseOrderReceiptData.isFetched) {
      if (
        purchaseOrderReceiptData.receiptStatus ==
        LogicConstants.PURCHASEORDER_RECEIPT_APPROVE_STATUS
      ) {
        this.setState({
          isShowUnApproveButton: false,
          isShowCancelButton: true,
          isShowApproveButton: false,
          isShowSaveButton: false,
          disableFormFields: true,
          // isShowExcelButton: true,
          // isShowPDFReportButton: true,
          isShowPORButton: false,
          isDisableButtons: false,
          isShowCreateInvoiceButton: true,
          isShowInTransitLookup: false,
          isDisablePoIntransit: true,
        });
      }
      if (
        purchaseOrderReceiptData.receiptStatus ==
        LogicConstants.PURCHASEORDER_RECEIPT_UNAPPROVE_STATUS
      ) {
        this.setState({
          isShowUnApproveButton: false,
          isShowCancelButton: true,
          isShowApproveButton: true,
          isShowSaveButton: true,
          disableFormFields: false,
          isShowExcelButton: true,
          isShowPDFReportButton: true,
          isShowPORButton: false,
          isDisableButtons: true,
          isShowCreateInvoiceButton: false,
          isShowInTransitLookup: true,
          isDisablePoIntransit: true,
        });
      }
      if (
        purchaseOrderReceiptData.receiptStatus ==
        LogicConstants.PURCHASEORDER_RECEIPT_CANCEL_STATUS
      ) {
        this.setState({
          isShowUnApproveButton: false,
          isShowCancelButton: false,
          isShowApproveButton: false,
          isShowSaveButton: false,
          disableFormFields: true,
          // isShowExcelButton: true,
          // isShowPDFReportButton: true,
          isShowPORButton: false,
          isDisableButtons: false,
          isShowCreateInvoiceButton: false,
          isShowInTransitLookup: false,
          isDisablePoIntransit: true,
        });
      }
      if (!purchaseOrderReceiptData.isFetched) {
        this.setState({
          isDisableButtons: true,
          isShowUnApproveButton: false,
          disableFormFields: true,
          isShowPORButton: false,
          isShowAutoCompletePurchaseOrderList: false,
          purchaseOrderPageListForAutoCompleteList: new Array(),
          isShowAutoCompleteRolllineLocationList: false,
          rollLineLocationPageListForAutoCompleteList: new Array(),
          isShowAutoCompleteLocationList: false,
          locationPageListForAutoCompleteList: new Array(),
          isShowAutoCompleteFobCityList: false,
          FobCityPageListForAutoCompleteList: new Array(),
          isShowAutoCompleteShipmentTermList: false,
          shipmentTermPageListForAutoCompleteList: new Array(),
          isShowAutoCompleteShipViaList: false,
          shipViaPageListForAutoCompleteList: new Array(),
          isShowAutoCompletePoIntransitList: false,
          poIntransitPageListForAutoCompleteList: new Array(),
          isShowCreateInvoiceButton: false,
          isShowInTransitLookup: true,
        });
      }
    }
    if (this.state.isViewMode) {
      let pageTitle = this.moduleCaption + " - VIEW";
      this.setState({
        disabled: true,
        pageTitle: pageTitle,
        disableFormFields: true,
        isDisablePoIntransit: true,
        isDisableButtons: false,
      });
    }
  };
  editPurchaseOrderReceipt = (receiptCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = receiptCode;
    let isLockRequired = NEW_ENTRY === receiptCode ? false : true;
    readrestInput.isLockRequired = isLockRequired;
    if (SecurityAccessManager.PurchaseOrderReceiptMaintenance_IsAccessible()) {
      PurchaseOrderReceiptService.initPurchaseOrderReceiptModule(
        readrestInput,
        this.editPOReceiptResponse,
        this.editPOReceiptError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      // disabled: true,
      isLoading: true,
    });
  };
  editPOReceiptResponse = (response) => {
    let errMsg = "";
    if (response.data.lockResponse != null) {
      if (!isEmpty(response.data.lockResponse.errors)) {
        this.showErrorMessage(response.data.lockResponse);
        this.state.isViewMode = true;
      }
    }
    if (response.data.purchaseOrderReceiptResponse != null) {
      if (response.data.purchaseOrderReceiptResponse.errors != null) {
        response.data.purchaseOrderReceiptResponse.errors.map((err) => {
          errMsg = err.messageDescription;
        });
      }
    }
    if (response.data.purchaseOrderReceiptResponse != null) {
      if (
        errMsg !=
        "Purchase Order Receipt [" + this.state.moduleKeyCode + "] Not read!"
      ) {
        this.showErrorMessage(response.data.purchaseOrderReceiptResponse);
      }
    }
    if (response.data.dependenciesResponse != null) {
      if (response.data.dependenciesResponse.dependenciesBean != null) {
        let fabricStyles =
          response.data.dependenciesResponse.dependenciesBean.fabricStyles;
        let purchaseOrderBean =
          response.data.dependenciesResponse.dependenciesBean.purchaseOrder;
        this.setState({
          fabricStyles: fabricStyles,
          purchaseOrderBean: purchaseOrderBean,
        });
      }
    }
    if (response.data.purchaseOrderReceiptResponse != null) {
      if (
        response.data.purchaseOrderReceiptResponse.purchaseOrderReceipt != null
      ) {
        let poReceiptBean =
          response.data.purchaseOrderReceiptResponse.purchaseOrderReceipt;
        let pageTitle = this.moduleCaption + " - EDIT";
        let moduleKeyCode = poReceiptBean.code;
        this.setState({
          purchaseOrderReceiptData: poReceiptBean,
          pageTitle: pageTitle,
          isFocusLookup: false,
          isFocus: true,
          moduleKeyCode: moduleKeyCode,
          isLoading: false,
        });
        this.isLocked = true;
        this.openEntryForm();
      } else {
        this.addNewEntry();
      }
    }
    this.setState({ isLoading: false });
  };
  editPOReceiptError = (error) => {
    this.showErrorMessage(error);
  };
  editPurchaseOrderReceiptLine = (val, rowData) => {
    let receiptData = this.state.purchaseOrderReceiptData;
    let receiptLineData = { ...rowData };
    let poReceiptRollLines_List = [];
    receiptLineData.receiptRollLines.map((ln) => {
      poReceiptRollLines_List.push(ln);
    });
    receiptLineData.purchaseOrderReceiptNumber = receiptData.code;
    receiptLineData.totalRolls = poReceiptRollLines_List.length;
    this.setState({
      purchaseOrderReceiptLineData: receiptLineData,
      poReceiptRollLinesList: poReceiptRollLines_List,
    });
  };
  onPurchaseOrderReceiptLineChange = (e) => {
    let purchaseOrderReceiptLineData = this.state.purchaseOrderReceiptLineData;
    purchaseOrderReceiptLineData[e.target.name] = e.target.value;
    this.setState({
      purchaseOrderReceiptLineData: purchaseOrderReceiptLineData,
    });
  };
  handleApproveResponse = (response) => {
    let success = false;
    let infoMsg = "";
    let errMsg = "";
    let errList = [];
    if (!isEmpty(response.mainOperationResponse)) {
      if (!isEmptyArray(response.mainOperationResponse.errors)) {
        response.mainOperationResponse.errors.map(
          (err) => (
            (errMsg = errMsg + err.messageDescription),
            errList.push(err.messageDescription)
          )
        );
        success = false;
      }
      if (!isEmptyArray(response.mainOperationResponse.infos)) {
        response.mainOperationResponse.infos.map(
          (info) => (infoMsg = infoMsg + info.messageDescription)
        );

        success = true;
      }
    }
    if (!isEmpty(response.additionalOperationResponse)) {
      if (!isEmptyArray(response.additionalOperationResponse.errors)) {
        response.additionalOperationResponse.errors.map(
          (err) => (
            (errMsg = errMsg + err.messageDescription),
            errList.push(err.messageDescription)
          )
        );

        success = false;
      }
      if (!isEmptyArray(response.additionalOperationResponse.infos)) {
        response.additionalOperationResponse.infos.map(
          (info) => (infoMsg = infoMsg + info.messageDescription)
        );

        success = true;
      }
    }
    if (!isEmptyArray(errList) && errList.length > 0) success = false;
    if (!isEmptyString(infoMsg) && !isEmptyString(errMsg)) {
      let msg = infoMsg + errMsg;
      let successMsg = [];
      successMsg.push(msg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
    } else if (!isEmptyString(infoMsg)) {
      let successMsg = [];
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
    } else if (!isEmptyArray(errList)) {
      // let errorMsg = [];
      // errorMsg.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({ error_list: errList });
    return success;
  };
  approvePurchaseOrderReceipt = (e) => {
    if (e.detail == 1) {
      this.setState({
        isLoading: true,
        loadingText: "Approving PO Receipt",
      });
      let poReceiptBean = this.state.purchaseOrderReceiptData;
      let inputRequest = new RestPurchaseOrderReceiptBeanRequest();
      inputRequest.purchaseOrderReceiptBean = poReceiptBean;
      inputRequest.companyCode = this.companyCode;
      if (poReceiptBean.isFetched) {
        inputRequest.isLockRequired = true;
      } else {
        inputRequest.isLockRequired = false;
      }
      if (poReceiptBean.isFetched) {
        if (
          SecurityAccessManager.PurchaseOrderReceiptMaintenanceApprove_IsAccessible()
        ) {
          PurchaseOrderReceiptService.updateAndApprovePurchaseOrderReceipt(
            inputRequest,
            this.approvePurchaseOrderReceiptResponse,
            this.approvePurchaseOrderReceiptError
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);
          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      } else {
        if (
          SecurityAccessManager.PurchaseOrderReceiptMaintenanceApprove_IsAccessible()
        ) {
          PurchaseOrderReceiptService.createAndApprovePurchaseOrderReceipt(
            inputRequest,
            this.approvePurchaseOrderReceiptResponse,
            this.approvePurchaseOrderReceiptError
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    }
  };

  approvePurchaseOrderReceiptResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.handleApproveResponse(response.data);
    if (
      response.data != null &&
      response.data.additionalOperationResponse != null
    ) {
      const purchaseOrderReceiptBean =
        response.data.additionalOperationResponse.purchaseOrderReceipt;
      if (purchaseOrderReceiptBean != null) {
        let pageTitle = this.moduleCaption + " - EDIT";
        this.setState({
          purchaseOrderReceiptData: purchaseOrderReceiptBean,
          pageTitle: pageTitle,
          disableFormFields: true,
        });
        if (!this.isLocked) {
          this.editPurchaseOrderReceipt(purchaseOrderReceiptBean.code);
        } else {
          this.code = purchaseOrderReceiptBean.code;
          this.unlockPurchaseOrderReceipt(purchaseOrderReceiptBean.code);
        }
      }
    }
  };
  approvePurchaseOrderReceiptError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error :" + error);
  };

  onLineCancelReasonContinue = () => {
    this.savePurchaseReceiptLineCancel();
    this.closeReasonModelCallBack();
  };
  savePurchaseReceiptLineCancel = () => {
    this.setState({
      isLoading: true,
      loadingText: "Cancelling PO Receipt",
    });
    let purchaseOrderReceiptLineData = this.state.purchaseOrderReceiptLineData;
    let input = new RestPurchaseOrderReceiptLineRequest();
    let temp_purchaseOrderReceiptLineSearchCriteria =
      new PurchaseOrderReceiptLineSearchCriteria();
    temp_purchaseOrderReceiptLineSearchCriteria.companyCode = this.companyCode;
    temp_purchaseOrderReceiptLineSearchCriteria.purchaseOrderNumber =
      purchaseOrderReceiptLineData.purchaseOrderNumber;
    temp_purchaseOrderReceiptLineSearchCriteria.purchaseOrderLineNumber =
      purchaseOrderReceiptLineData.purchaseOrderLineNumber;
    temp_purchaseOrderReceiptLineSearchCriteria.purchaseOrderReceiptNumber =
      purchaseOrderReceiptLineData.purchaseOrderReceiptNumber;
    temp_purchaseOrderReceiptLineSearchCriteria.purchaseOrderReceiptLineNumber =
      purchaseOrderReceiptLineData.lineNumber;
    input.companyCode = this.companyCode;
    input.lineSearchCriteria = temp_purchaseOrderReceiptLineSearchCriteria;
    input.reason = this.state.reasonData;
    input.isLockRequired = true;
    if (
      SecurityAccessManager.PurchaseOrderReceiptMaintenanceCancel_IsAccessible()
    ) {
      PurchaseOrderReceiptService.cancelPurchaseOrderReceiptLine(
        input,
        this.savePurchaseOrderLineCancelResponse,
        this.savePurchaseOrderLineCancelError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  savePurchaseOrderLineCancelResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.handleResponse(response.data);
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.purchaseOrderReceipt.lines)
    ) {
      let purchaseOrderReceipt = response.data.purchaseOrderReceipt;
      this.setState({
        purchaseOrderReceiptData: purchaseOrderReceipt,
      });
      // this.unlockPurchaseOrderReceipt(response.data.purchaseOrderReceipt.code);
      // this.editPurchaseOrderReceipt(response.data.purchaseOrderReceipt.code);
      if (this.isLocked) {
        this.code = purchaseOrderReceipt.code;
        this.unlockPurchaseOrderReceipt(
          response.data.purchaseOrderReceipt.code
        );
      }
    }
  };
  savePurchaseOrderLineCancelError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error cancel line: " + error);
  };
  onRollLineCancelReasonContinue = () => {
    // let isValid = false;
    // isValid = this.isValidReason();
    // if (isValid) {
    //   if (
    //     !isEmpty(this.rollLineCancelReasonDialogRef) &&
    //     !isEmpty(this.rollLineCancelReasonDialogRef.current)
    //   ) {
    //     this.rollLineCancelReasonDialogRef.current.closeDialog();
    //   }
    // }
    this.closeReasonModelCallBack();
  };
  reArrangeRollLineDisplayNumbers = (lineList) => {
    let maxLineNumber = 0;
    lineList.map((line) => {
      ++maxLineNumber;
      line.receiptRollLineNumber = maxLineNumber;
    });
  };
  deleteReceiptRollLine = (rowData) => {
    let receiptLineData = this.state.purchaseOrderReceiptLineData;
    let lines = this.state.poReceiptRollLinesList;
    if (!rowData.isFetched) {
      if (!isEmptyArray(lines)) {
        var index1 = lines.indexOf(rowData);
        if (index1 > -1) {
          lines.splice(index1, 1);
        }
        this.reArrangeRollLineDisplayNumbers(lines);
        this.setReceivedQtyValues(lines);
        this.state.poReceiptRollLinesList = lines;
      }
    } else {
      let errMsg = "Already Existing PurchaseRoll Lines";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowPopupAlert: true,
      });
    }
  };
  setReceivedQtyValues = (lines) => {
    let lineData = this.state.purchaseOrderReceiptLineData;
    let receivedQty = 0;
    lines.map((ln) => {
      receivedQty += parseFloat(ln.receivedQuantity);
    });
    lineData.receivedQuantity = parseFloat(receivedQty).toFixed(2);
    lineData.totalRolls = lines.length;
    this.setState({
      purchaseOrderReceiptLineData: lineData,
      poReceiptRollLinesList: lines,
    });
  };
  isValidReason = () => {
    let isValid = true;
    let err_list = [];
    let errorMsg = "";
    if (isEmpty(this.state.reasonData)) {
      let errMsg = " Reason is Required";
      errorMsg = errorMsg + errMsg;
      err_list.push(errMsg);
    }
    if (isEmptyString(this.state.reasonData.code)) {
      let errMsg = " Reason is Required";
      errorMsg = errorMsg + errMsg;
      err_list.push(errMsg);
    }
    this.setState({ error_list: err_list });
    if (err_list.length > 0) isValid = false;
    return isValid;
  };
  saveCancelPurchaseOrderReceipt = () => {
    let poBean = this.state.purchaseOrderReceiptData;
    let purchaseReceiptRequest = new RestPurchaseOrderReceiptRequest();
    purchaseReceiptRequest.purchaseOrderReceiptBean = poBean;
    purchaseReceiptRequest.reason = this.state.reasonData;
    if (
      SecurityAccessManager.PurchaseOrderReceiptMaintenanceCancel_IsAccessible()
    ) {
      PurchaseOrderReceiptService.cancelAndUnLockPurchaseOrderReceipt(
        purchaseReceiptRequest,
        this.cancelPurchaseOrderReceiptResponse,
        this.cancelPurchaseOrderReceiptError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  cancelPurchaseOrderReceiptResponse = (response) => {
    this.handleResponse(response.data);
    if (response.data != null && response.data.mainOperationResponse != null) {
      this.handleResponse(response.data.mainOperationResponse);
      const purchaseOrderReceiptBean =
        response.data.mainOperationResponse.purchaseOrderReceipt;
      if (purchaseOrderReceiptBean != null) {
        let pageTitle = this.moduleCaption + " - EDIT";
        this.setState({
          purchaseOrderReceiptData: purchaseOrderReceiptBean,
          pageTitle: pageTitle,
          disableFormFields: true,
          isLoading: false,
          loadingText: "",
        });
        this.editPurchaseOrderReceipt(purchaseOrderReceiptBean.code);
      }
    }
  };
  cancelPurchaseOrderReceiptError = (error) => {
    ShowError("Error :" + error);
  };
  onReasonDescChange = (e) => {
    let reasonData = this.state.reasonData;
    reasonData[e.target.name] = e.target.value;
    this.setState({ reasonData: reasonData });
  };
  onReasonChange = (e) => {
    let code = e.target.value;
    this.state.showAutoCompleteReasonList = true;

    let reasonData = this.state.reasonData;
    let showAutoCompleteList = this.state.showAutoCompleteReasonList;

    if (isEmpty(code)) {
      this.state.showAutoCompleteReasonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteReasonList;
      let reason = this.state.reasonData;
      reason.code = "";
      reason.description = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteReasonList: showAutoCompleteList,
        reasonData: reason,
        reasonPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && code !== "") {
      this.readReasonBySearchString(code);
    }
    if (e.target.name == "code") {
      reasonData["code"] = e.target.value;
      let reasonList = this.state.cancelReasons;
      reasonList.map((rsn) => {
        if (rsn.code == e.target.value) {
          reasonData["code"] = rsn.code;
          this.state.showAutoCompleteReasonList = false;
          let showAutoCompleteList = this.state.showAutoCompleteReasonList;
          this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
        }
      });
    }

    this.setState({ reasonData: reasonData });
  };
  readReasonBySearchString(searchString) {
    let reasonData = this.state.cancelReasons;
    let simpleAutoCompleteList = new Array();
    if (reasonData.length > 0 && reasonData != null) {
      reasonData.map((reasons) => {
        let simpleItemBean = {
          code: reasons.code,
          description: reasons.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteLocationLists) =>
        simpleAutoCompleteLocationLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ reasonPageListForAutoCompleteList: filteredSuggestions });
  }
  reasonEnterKeyEventHandler = (e) => {
    let reasonData = this.state.reasonData;
    let code = e.target.value;

    reasonData["code"] = e.target.value;
    let reasonList = this.state.cancelReasons;
    let reasonCodeBean = null;
    reasonList.map((rsn) => {
      if (rsn.code == e.target.value) {
        reasonCodeBean = rsn;
      }
    });
    if (!isEmpty(reasonCodeBean)) {
      let reasonData = this.state.reasonData;
      reasonData.code = reasonCodeBean.code;
      this.setState({
        reasonData: reasonData,
        reasonPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteReasonList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
  };
  closeReasonModelCallBack = () => {
    this.setState({
      isShowCancelReasonPopup: false,
      reasonData: new ReasonBean(),
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      isShowLineCancelReasonPopup: false,
      isShowRollLineCancelReasonPopup: false,
    });
  };
  openReasonCapture = (type) => {
    if (type === 1) {
      this.setState({
        isShowCancelReasonPopup: true,
      });
    } else if (type === 2) {
      this.setState({
        isShowUnApproveReasonPopup: true,
      });
    } else if (type === 3) {
      this.setState({
        isShowLineCancelReasonPopup: true,
      });
    } else if (type === 3) {
      this.setState({
        isShowRollLineCancelReasonPopup: true,
      });
    }
    this.setState({
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
    });
  };
  onCancelReasonContinue = () => {
    this.setState({
      isLoading: true,
      loadingText: "Cancelling ...",
    });
    this.saveCancelPurchaseOrderReceipt();
    this.closeReasonModelCallBack();
  };
  cancelPurchaseOrderReceipt = (e) => {
    if (e.detail == 1) this.openReasonCapture(1);
  };
  addOrUpdatePurchaseOrderReceiptLine = () => {
    let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
    let lines = [];
    lines = purchaseOrderReceiptData.lines;
    let purchaseOrderReceiptLineData = this.state.purchaseOrderReceiptLineData;
    purchaseOrderReceiptLineData.receiptRollLines =
      this.state.poReceiptRollLinesList;
    if (!isEmptyArray(lines)) {
      lines.map((line, i) => {
        if (line.lineNumber == purchaseOrderReceiptLineData.lineNumber) {
          lines[i] = purchaseOrderReceiptLineData;
        }
      });
    }
    purchaseOrderReceiptData.lines = lines;
    this.setState({
      purchaseOrderReceiptData: purchaseOrderReceiptData,
      isShowPopup: false,
    });
    this.closePoReceiptLinePopup();
  };
  closePoReceiptLinePopup = () => {
    this.setState({
      poReceiptRollLinesList: new Array(),
    });
  };
  editPurchaseOrderReceiptRollLine = (val, rowData) => {
    let rollLineData = { ...rowData };
    this.setState({ purchaseOrderReceiptRollLineData: rollLineData });
    if (rowData.isFetched) {
      this.setState({
        isDisableRollLine: true,
        disableFormFields: true,
      });
    }
  };
  onPurchaseOrderReceiptRollLineChange = (e) => {
    let purchaseOrderReceiptRollLineData =
      this.state.purchaseOrderReceiptRollLineData;
    purchaseOrderReceiptRollLineData[e.target.name] = e.target.value;
    this.setState({
      purchaseOrderReceiptRollLineData: purchaseOrderReceiptRollLineData,
    });
  };
  validatePOReceiptLines = (PoLine) => {
    let isValidPoReceiptBean = false;
    let err_list = [];
    let errorMessage = "";
    if (PoLine == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (
        isEmptyString(PoLine.receivedQuantity) ||
        PoLine.receivedQuantity <= 0
      ) {
        let errMsg = "Invalid ReceivedQty";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(PoLine.vendorLotNumber)) {
        let errMsg = "Invalid VENDOR LOT";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidPoReceiptBean = false;
      this.setState({ errorList: err_list });
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: false,
        isShowPopupAlert: false,
        isShowPopupAlertlvl1: false,
        isShowPopupAlertlvl5: true,
      });
    } else {
      isValidPoReceiptBean = true;
      this.setState({
        isShowAlert: false,
        isShowPopupAlert: false,
        isShowPopupAlertlvl1: false,
        isShowPopupAlertlvl5: false,
      });
    }
    return isValidPoReceiptBean;
  };
  addOrUpdatePurchaseOrderReceiptRollLine = (e) => {
    let purchaseOrderReceiptLineData = this.state.purchaseOrderReceiptLineData;
    let receiptData = this.state.purchaseOrderReceiptData;
    let purchaseOrderReceiptRollLineData =
      this.state.purchaseOrderReceiptRollLineData;
    let poReceiptRollLines_List = this.state.poReceiptRollLinesList;
    let receivedQty = 0;
    let isValidLine = false;
    isValidLine = this.validatePOReceiptLines(purchaseOrderReceiptRollLineData);
    if (isValidLine) {
      let rollLineFound = false;
      if (!isEmptyArray(poReceiptRollLines_List)) {
        poReceiptRollLines_List.map((line, i) => {
          if (
            line.receiptRollLineNumber ==
            purchaseOrderReceiptRollLineData.receiptRollLineNumber
          ) {
            poReceiptRollLines_List[i] = purchaseOrderReceiptRollLineData;
            rollLineFound = true;
          }
        });
      }
      if (!rollLineFound) {
        poReceiptRollLines_List.push(purchaseOrderReceiptRollLineData);
      }
      if (!isEmptyArray(poReceiptRollLines_List)) {
        poReceiptRollLines_List.map((ln) => {
          receivedQty += parseFloat(ln.receivedQuantity);
        });
      }
      purchaseOrderReceiptLineData.receivedQuantity =
        parseFloat(receivedQty).toFixed(2);
      purchaseOrderReceiptLineData.totalRolls = poReceiptRollLines_List.length;
      this.setState({
        poReceiptRollLinesList: poReceiptRollLines_List,
        purchaseOrderReceiptLineData: purchaseOrderReceiptLineData,
      });
      this.closeLinePopup();
    }
  };
  addNewRollLine = (e) => {
    let purchaseOrderReceiptLineData = this.state.purchaseOrderReceiptLineData;
    let poReceiptRollLines_List = this.state.poReceiptRollLinesList;
    let rollLineNumber = 0;
    if (!isEmptyArray(poReceiptRollLines_List)) {
      poReceiptRollLines_List.map((roll) => {
        if (roll.receiptRollLineNumber > 0)
          rollLineNumber = roll.receiptRollLineNumber;
      });
    }
    rollLineNumber++;
    let rollLineData = new PurchaseOrderReceiptRollLineBean();
    rollLineData.companyCode = purchaseOrderReceiptLineData.companyCode;
    rollLineData.purchaseOrderReceiptNumber =
      purchaseOrderReceiptLineData.purchaseOrderReceiptNumber;
    rollLineData.receiptRollLineNumber = rollLineNumber;
    rollLineData.receiptLineNumber = purchaseOrderReceiptLineData.lineNumber;
    rollLineData.rollNumber = rollLineNumber;
    rollLineData.locationCode = purchaseOrderReceiptLineData.locationCode;
    rollLineData.fabricStyleCode = purchaseOrderReceiptLineData.fabricStyleCode;
    rollLineData.fabricStyleName = purchaseOrderReceiptLineData.fabricStyleName;
    rollLineData.widthCode = purchaseOrderReceiptLineData.widthCode;
    rollLineData.uomCode = purchaseOrderReceiptLineData.uomCode;
    rollLineData.colorCode = purchaseOrderReceiptLineData.colorCode;
    rollLineData.skuNumber = purchaseOrderReceiptLineData.skuNumber;
    rollLineData.inventoryUomCode =
      purchaseOrderReceiptLineData.inventoryUomCode;
    rollLineData.uomConversionRate =
      purchaseOrderReceiptLineData.uomConversionRate;
    rollLineData.inTransitQuantity =
      purchaseOrderReceiptLineData.inTransitQuantity;
    this.setState({ purchaseOrderReceiptRollLineData: rollLineData });
  };
  addNewEntry = () => {
    let purchaseOrderReceiptData = new PurchaseOrderReceiptBean();
    this.setState({
      purchaseOrderReceiptData: purchaseOrderReceiptData,
    });
    this.setNewPurchaseOrderDefaultData(purchaseOrderReceiptData);
    this.openEntryForm();
  };
  setNewPurchaseOrderDefaultData = (purchaseOrderReceiptData) => {
    purchaseOrderReceiptData.companyCode = this.companyCode;
    purchaseOrderReceiptData.receiptStatus =
      LogicConstants.PURCHASE_ORDER_UNAPPROVE_STATUS;
    purchaseOrderReceiptData.currencyCode = "USD";
    let pageTitle = this.moduleCaption + " - NEW";
    if (
      this.state.moduleKeyCode != NEW_ENTRY &&
      !isEmptyString(this.state.moduleKeyCode)
    ) {
      purchaseOrderReceiptData.code = this.state.moduleKeyCode;
    } else {
      purchaseOrderReceiptData.code = NEW_ENTRY;
    }
    if (this.state.moduleKeyCode == NEW_ENTRY) {
      this.isLocked = false;
    } else {
      this.isLocked = true;
    }
    purchaseOrderReceiptData.receiptDate = new Date();
    purchaseOrderReceiptData.createdDate = new Date();
    this.setState({
      purchaseOrderReceiptData: purchaseOrderReceiptData,
      pageTitle: pageTitle,
      isLoading: false,
    });
    this.state.purchaseOrderReceiptData = purchaseOrderReceiptData;
  };
  getPurchaseOrderLinesDatasFromExcel = () => {
    this.setState({
      isLoading: true,
      loadingText: "Loading Excel Dtaata",
    });
    let purchaseOrderReceiptLineData = this.state.purchaseOrderReceiptLineData;
    let selectedDocument = this.state.selectedDocument;
    let readrestInput = new RestPurchaseOrderReceiptExcelImportRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.purchaseOrderNumber =
      purchaseOrderReceiptLineData.purchaseOrderNumber;
    readrestInput.excelFileName = selectedDocument;
    if (SecurityAccessManager.PurchaseOrderReceiptMaintenance_IsAccessible()) {
      PurchaseOrderReceiptService.getPurchaseOrderLinesDatasFromExcel(
        readrestInput,
        this.getPoLineDataExcelResponse,
        this.getPoLineDataExcelError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  getPoLineDataExcelResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.handleResponse(response.data);
    let inputBean = response.data.einput;
    this.setState({
      purchaseOrderReceiptElectronicInputBean: inputBean,
    });

    this.toGenerateRollLinesFromExcelInputBean();
  };
  getPoLineDataExcelError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("error :", error);
  };
  toGenerateRollLinesFromExcelInputBean = () => {
    let purchaseOrderReceiptElectronicInputBean =
      this.state.purchaseOrderReceiptElectronicInputBean;
    let purchaseOrderReceiptLineData = this.state.purchaseOrderReceiptLineData;
    if (!purchaseOrderReceiptLineData) {
      return;
    }
    if (!purchaseOrderReceiptLineData.fabricStyleCode) {
      return;
    }
    let receiptRollLines = [];
    receiptRollLines = this.state.poReceiptRollLinesList;
    let rollLineNumber = 0;
    let receivedQuantity = 0;
    let rollLines = purchaseOrderReceiptElectronicInputBean.rollLines;
    if (rollLines != null && !isEmptyArray(rollLines)) {
      for (let list of rollLines) {
        if (
          list.fabricStyleCode ===
            purchaseOrderReceiptLineData.fabricStyleCode &&
          list.colorCode === purchaseOrderReceiptLineData.colorCode
        ) {
          rollLineNumber++;
          let rollLineData = new PurchaseOrderReceiptRollLineBean();
          rollLineData.companyCode = purchaseOrderReceiptLineData.companyCode;
          rollLineData.purchaseOrderReceiptNumber =
            purchaseOrderReceiptLineData.purchaseOrderReceiptNumber;
          rollLineData.receiptRollLineNumber = rollLineNumber;
          rollLineData.receiptLineNumber =
            purchaseOrderReceiptLineData.lineNumber;
          rollLineData.locationCode = purchaseOrderReceiptLineData.locationCode;
          rollLineData.fabricStyleCode =
            purchaseOrderReceiptLineData.fabricStyleCode;
          rollLineData.fabricStyleName =
            purchaseOrderReceiptLineData.fabricStyleName;
          rollLineData.widthCode = purchaseOrderReceiptLineData.widthCode;
          rollLineData.uomCode = purchaseOrderReceiptLineData.uomCode;
          rollLineData.colorCode = purchaseOrderReceiptLineData.colorCode;
          rollLineData.skuNumber = purchaseOrderReceiptLineData.skuNumber;
          rollLineData.inventoryUomCode =
            purchaseOrderReceiptLineData.inventoryUomCode;
          rollLineData.uomConversionRate =
            purchaseOrderReceiptLineData.uomConversionRate;
          rollLineData.inTransitQuantity =
            purchaseOrderReceiptLineData.inTransitQuantity;
          rollLineData.rollNumber = list.rollNumber;
          rollLineData.receivedQuantity = list.quantity;
          rollLineData.inventoryReceivedQuantity = list.quantity;
          rollLineData.vendorLotNumber = list.lotNumber;
          rollLineData.boxNumber = list.boxNumber;
          rollLineData.aisleInfoText = list.aisleInfoText;
          rollLineData.infoText = list.infoText;
          receivedQuantity = receivedQuantity + parseFloat(list.quantity);
          receiptRollLines.push(rollLineData);
        } else {
          let errMsg =
            "Load Roll from Excel File, No Matching inTransitRoll Data for this FabricStyle / Color";
          let errList = [];
          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    }
    purchaseOrderReceiptLineData.totalRolls = rollLines.length;
    purchaseOrderReceiptLineData.receivedQuantity = receivedQuantity.toFixed(2);
    this.setState({
      purchaseOrderReceiptLineData: purchaseOrderReceiptLineData,
      poReceiptRollLinesList: receiptRollLines,
    });
  };
  uploadExcelFile = (e) => {
    let file = e.target.files[0];
    let fileName = file.name;
    let fileData = new File([file], `${fileName}`, { type: file.type });
    let formData = new FormData();
    formData.append("file", fileData);
    this.setState({ selectedDocument: fileName });
    if (SecurityAccessManager.PurchaseOrderReceiptMaintenance_IsAccessible()) {
      PurchaseOrderReceiptService.uploadExcelInput(
        formData,
        this.uploadRollLineExcelResponse,
        this.uploadRollLineExcelError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  uploadRollLineExcelResponse = (response) => {
    if (response.data != null) {
      if (response.data.success == true) {
        this.getPurchaseOrderLinesDatasFromExcel();
      }
    }
  };
  uploadRollLineExcelError = (error) => {};
  reArrangePurchaseReceiptLineNumbers = (LineList) => {
    let maxLineNumber = 0;
    LineList.map((line) => {
      ++maxLineNumber;
      line.lineNumber = maxLineNumber;
    });
  };
  cancelPurchaseReceiptLine = (receiptlineData) => {
    let purchaseOrderReceiptLineData = receiptlineData;
    let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
    let existingLine = this.getReceiptLinebyLineNumber(
      receiptlineData.lineNumber
    );
    this.state.purchaseOrderReceiptLineData = { ...existingLine };
    if (!isEmpty(existingLine)) {
      if (!existingLine.isFetched) {
        const index = purchaseOrderReceiptData.lines.findIndex(
          (ln) => ln.lineNumber === existingLine.lineNumber
        );
        if (index != -1) {
          purchaseOrderReceiptData.lines.splice(index, 1);
        }
        this.setState({
          purchaseOrderReceiptData: purchaseOrderReceiptData,
        });
      } else {
        this.openReasonCapture(3);
      }
    }
    this.reArrangePurchaseReceiptLineNumbers(purchaseOrderReceiptData.lines);
    this.setState({
      purchaseOrderReceiptLineData: purchaseOrderReceiptLineData,
    });
  };
  getReceiptLinebyLineNumber = (lineNumber) => {
    let receiptLine = null;
    if (this.state.purchaseOrderReceiptData === null) return receiptLine;
    else if (this.state.purchaseOrderReceiptData.lines === null)
      return receiptLine;
    else {
      this.state.purchaseOrderReceiptData.lines.map((line) => {
        if (line.lineNumber === lineNumber) {
          receiptLine = line;
          return receiptLine;
        }
      });
    }
    return receiptLine;
  };
  onLineChange = (e) => {
    let temp_addressBean = this.state.purchaseOrderReceiptLineData;
    if (temp_addressBean == null || temp_addressBean == "undefined") {
      temp_addressBean = new AddressBean();
    }
    temp_addressBean[e.target.name] = e.target.value;
    this.setState({ purchaseOrderReceiptLineData: temp_addressBean });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
    this.closePoIntransitModalCallBack(false);
  };
  lnkPOModule = () => {
    let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
    let code = purchaseOrderReceiptData.purchaseOrderNumber;
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowPurchaseOrderModule: true,
        moduleForPopup: (
          <PopupPurchaseOrderModule
            code={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  lnkPOIntransitModule = () => {
    let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
    let code = purchaseOrderReceiptData.purchaseOrderInTransitNumber;
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowPurchaseOrderInTransitModule: true,
        moduleForPopup: (
          <PopupPurchaseInTransitModule
            code={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  closePoIntransitModalCallBack = (isOpen) => {
    this.setState({
      isShowPurchaseOrderInTransitModule: isOpen,
      moduleForPopup: [],
    });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({ isShowPurchaseOrderModule: isOpen, moduleForPopup: [] });
  };
  showLinePopup = () => {
    this.setState({ isShowLinePopup: true });
  };
  closeLinePopup = () => {
    this.setState({ isShowLinePopup: false });
  };
  rollLineLocationOnChange = (e) => {
    let locationCode = e.target.value;
    this.state.isShowAutoCompleteRolllineLocationLists = true;
    let tempCriteria = this.state.purchaseOrderReceiptRollLineData;
    let showAutoCompleteList =
      this.state.isShowAutoCompleteRolllineLocationList;
    if (isEmpty(locationCode)) {
      this.state.isShowAutoCompleteRolllineLocationList = false;
      let showAutoCompleteList =
        this.state.isShowAutoCompleteRolllineLocationList;
      let tempCriteria = this.state.purchaseOrderReceiptRollLineData;
      tempCriteria.locationCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        purchaseOrderReceiptRollLineData: tempCriteria,
        rollLineLocationPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "locationCode" &&
      showAutoCompleteList === true &&
      locationCode !== ""
    ) {
      this.readRollLineLocationBySearchString(e.target.value);
    }
    this.readRollLineLocation(locationCode);
    tempCriteria[e.target.name] = e.target.value.toUpperCase();
    this.setState({ purchaseOrderReceiptRollLineData: tempCriteria });
  };
  rollLineLocationEnterKeyEventHandler = (e) => {
    let locationCode = e.target.value;
    this.readRollLineLocation(locationCode);
    this.state.isShowAutoCompleteRolllineLocationList = false;
    let showAutoCompleteList =
      this.state.isShowAutoCompleteRolllineLocationList;
    this.setState({
      rollLineLocationPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayRollLineLocationAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteRolllineLocationList: isShowAutoCompleteList,
    });
  };
  readRollLineLocation = (locationCode) => {
    let tempCriteria = this.state.purchaseOrderReceiptRollLineData;
    let locationBean = null;
    let locationData = null;
    this.state.wareHouses.map((ln) => {
      if (ln.code === locationCode) {
        locationBean = ln;
        locationData = new BaseBean();
        locationData.code = ln.code;
        locationData.description = ln.description;
      }
    });
    if (!isEmpty(locationBean)) {
      tempCriteria.locationCode = locationBean.code;
      this.state.isShowAutoCompleteRolllineLocationList = false;
      let showAutoCompleteList =
        this.state.isShowAutoCompleteRolllineLocationList;
      this.setState({
        purchaseOrderReceiptRollLineData: tempCriteria,
        isShowAutoCompleteRolllineLocationList: showAutoCompleteList,
      });
    }
  };
  readRollLineLocationBySearchString = (searchString) => {
    let locationData = this.state.wareHouses;
    let simpleAutoCompleteList = new Array();
    if (locationData.length > 0 && locationData != null) {
      locationData.map((location) => {
        let locationBean = {
          code: location.code,
          description: location.description,
        };
        simpleAutoCompleteList.push(locationBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      rollLineLocationPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  locationOnChange = (e) => {
    let locationCode = e.target.value;
    this.state.isShowAutoCompleteLocationList = true;
    let tempCriteria = this.state.purchaseOrderReceiptData;
    let showAutoCompleteList = this.state.isShowAutoCompleteLocationList;
    if (isEmpty(locationCode)) {
      this.state.isShowAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteLocationList;
      let tempCriteria = this.state.purchaseOrderReceiptData;
      tempCriteria.locationCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        purchaseOrderReceiptData: tempCriteria,
        locationPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "locationCode" &&
      showAutoCompleteList === true &&
      locationCode !== ""
    ) {
      this.readLocationBySearchString(e.target.value);
    }
    this.readLocation(locationCode);
    tempCriteria[e.target.name] = e.target.value.toUpperCase();
    this.setState({ purchaseOrderReceiptData: tempCriteria });
  };
  locationEnterKeyEventHandler = (e) => {
    let locationCode = e.target.value;
    this.readLocation(locationCode);
    this.state.isShowAutoCompleteLocationList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteLocationList;
    this.setState({
      locationPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayLocationAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteLocationList: isShowAutoCompleteList,
    });
  };
  readLocation = (locationCode) => {
    let tempCriteria = this.state.purchaseOrderReceiptData;
    let locationBean = null;
    let locationData = null;
    this.state.wareHouses.map((ln) => {
      if (ln.code === locationCode) {
        locationBean = ln;
        locationData = new BaseBean();
        locationData.code = ln.code;
        locationData.description = ln.description;
      }
    });
    if (!isEmpty(locationBean)) {
      tempCriteria.locationCode = locationBean.code;
      this.state.isShowAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteLocationList;
      this.setState({
        purchaseOrderReceiptData: tempCriteria,
        isShowAutoCompleteLocationList: showAutoCompleteList,
      });
    }
  };
  readLocationBySearchString = (searchString) => {
    let locationData = this.state.wareHouses;
    let simpleAutoCompleteList = new Array();
    if (locationData.length > 0 && locationData != null) {
      locationData.map((location) => {
        let locationBean = {
          code: location.code,
          description: location.description,
        };
        simpleAutoCompleteList.push(locationBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      locationPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  fobCityOnChange = (e) => {
    let fOBCity = e.target.value;
    this.state.isShowAutoCompleteFobCityList = true;
    let tempCriteria = this.state.purchaseOrderReceiptData;
    let showAutoCompleteList = this.state.isShowAutoCompleteFobCityList;
    if (isEmpty(fOBCity)) {
      this.state.isShowAutoCompleteFobCityList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteFobCityList;
      let tempCriteria = this.state.purchaseOrderReceiptData;
      tempCriteria.fOBCity = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        purchaseOrderReceiptData: tempCriteria,
        FobCityPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "fOBCity" &&
      showAutoCompleteList === true &&
      fOBCity !== ""
    ) {
      this.readFobCityBySearchString(e.target.value);
    }
    this.readFobCity(fOBCity);
    tempCriteria[e.target.name] = e.target.value.toUpperCase();
    this.setState({ purchaseOrderReceiptData: tempCriteria });
  };

  fobCityEnterKeyEventHandler = (e) => {
    let fOBCity = e.target.value;
    this.readFobCity(fOBCity);
    this.state.isShowAutoCompleteFobCityList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteFobCityList;
    this.setState({
      FobCityPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayFobCityAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteFobCityList: isShowAutoCompleteList,
    });
  };
  readFobCity = (fOBCity) => {
    let tempCriteria = this.state.purchaseOrderReceiptData;
    let fobCityBean = null;
    let fobCityData = null;
    this.state.fOBCities.map((ln) => {
      if (ln.code === fOBCity) {
        fobCityBean = ln;
        fobCityData = new BaseBean();
        fobCityData.code = ln.code;
        fobCityData.description = ln.description;
      }
    });
    if (!isEmpty(fobCityBean)) {
      tempCriteria.fOBCity = fobCityBean.code;
      this.state.isShowAutoCompleteFobCityList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteFobCityList;
      this.setState({
        purchaseOrderReceiptData: tempCriteria,
        isShowAutoCompleteFobCityList: showAutoCompleteList,
      });
    }
  };
  readFobCityBySearchString = (searchString) => {
    let fobCityData = this.state.fOBCities;
    let simpleAutoCompleteList = new Array();
    if (fobCityData.length > 0 && fobCityData != null) {
      fobCityData.map((fobCity) => {
        let fobCityBean = {
          code: fobCity.code,
          description: fobCity.description,
        };
        simpleAutoCompleteList.push(fobCityBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      FobCityPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  shipmentTermOnChange = (e) => {
    let shipmentTermsCode = e.target.value;
    this.state.isShowAutoCompleteShipmentTermList = true;
    let tempCriteria = this.state.purchaseOrderReceiptData;
    let showAutoCompleteList = this.state.isShowAutoCompleteShipmentTermList;
    if (isEmpty(shipmentTermsCode)) {
      this.state.isShowAutoCompleteShipmentTermList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteShipmentTermList;
      let tempCriteria = this.state.purchaseOrderReceiptData;
      tempCriteria.shipmentTermsCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        purchaseOrderReceiptData: tempCriteria,
        shipmentTermPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "shipmentTermsCode" &&
      showAutoCompleteList === true &&
      shipmentTermsCode !== ""
    ) {
      this.readShipmentTermBySearchString(e.target.value);
    }
    this.readShipmentTerm(shipmentTermsCode);
    tempCriteria[e.target.name] = e.target.value.toUpperCase();
    this.setState({ purchaseOrderReceiptData: tempCriteria });
  };

  shipmentTermEnterKeyEventHandler = (e) => {
    let shipmentTermsCode = e.target.value;
    this.readShipmentTerm(shipmentTermsCode);
    this.state.isShowAutoCompleteShipmentTermList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteShipmentTermList;
    this.setState({
      shipmentTermPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayShipmentTermAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteShipmentTermList: isShowAutoCompleteList,
    });
  };
  readShipmentTerm = (shipmentTermsCode) => {
    let tempCriteria = this.state.purchaseOrderReceiptData;
    let shipmentTermBean = null;
    let shipmentTermData = null;
    this.state.shipmentTerms.map((ln) => {
      if (ln.code === shipmentTermsCode) {
        shipmentTermBean = ln;
        shipmentTermData = new BaseBean();
        shipmentTermData.code = ln.code;
        shipmentTermData.description = ln.description;
      }
    });
    if (!isEmpty(shipmentTermBean)) {
      tempCriteria.shipmentTermsCode = shipmentTermBean.code;
      this.state.isShowAutoCompleteShipmentTermList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteShipmentTermList;
      this.setState({
        purchaseOrderReceiptData: tempCriteria,
        isShowAutoCompleteShipmentTermList: showAutoCompleteList,
      });
    }
  };
  readShipmentTermBySearchString = (searchString) => {
    let shipmentTermData = this.state.shipmentTerms;
    let simpleAutoCompleteList = new Array();
    if (shipmentTermData.length > 0 && shipmentTermData != null) {
      shipmentTermData.map((shipmentTerm) => {
        let shipmentTermBean = {
          code: shipmentTerm.code,
          description: shipmentTerm.description,
        };
        simpleAutoCompleteList.push(shipmentTermBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      shipmentTermPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  shipViaOnChange = (e) => {
    let shipViaCode = e.target.value;
    this.state.isShowAutoCompleteShipViaList = true;
    let tempCriteria = this.state.purchaseOrderReceiptData;
    let showAutoCompleteList = this.state.isShowAutoCompleteShipViaList;
    if (isEmpty(shipViaCode)) {
      this.state.isShowAutoCompleteShipViaList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteShipViaList;
      let tempCriteria = this.state.purchaseOrderReceiptData;
      tempCriteria.shipViaCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        purchaseOrderReceiptData: tempCriteria,
        shipViaPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "shipViaCode" &&
      showAutoCompleteList === true &&
      shipViaCode !== ""
    ) {
      this.readShipViaBySearchString(e.target.value);
    }
    this.readShipVia(shipViaCode);
    tempCriteria[e.target.name] = e.target.value.toUpperCase();
    this.setState({ purchaseOrderReceiptData: tempCriteria });
  };
  shipViaEnterKeyEventHandler = (e) => {
    let shipViaCode = e.target.value;
    this.readShipVia(shipViaCode);
    this.state.isShowAutoCompleteShipViaList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteShipViaList;
    this.setState({
      shipViaPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayShipViaAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteShipViaList: isShowAutoCompleteList,
    });
  };
  readShipVia = (shipViaCode) => {
    let tempCriteria = this.state.purchaseOrderReceiptData;
    let shipViaBean = null;
    let shipViaData = null;
    this.state.shipVias.map((ln) => {
      if (ln.code === shipViaCode) {
        shipViaBean = ln;
        shipViaData = new BaseBean();
        shipViaData.code = ln.code;
        shipViaData.description = ln.description;
      }
    });
    if (!isEmpty(shipViaBean)) {
      tempCriteria.shipViaCode = shipViaBean.code;
      this.state.isShowAutoCompleteShipViaList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteShipViaList;
      this.setState({
        purchaseOrderReceiptData: tempCriteria,
        isShowAutoCompleteShipViaList: showAutoCompleteList,
      });
    }
  };
  readShipViaBySearchString = (searchString) => {
    let shipViaData = this.state.shipVias;
    let simpleAutoCompleteList = new Array();
    if (shipViaData.length > 0 && shipViaData != null) {
      shipViaData.map((shipVia) => {
        let shipViaBean = {
          code: shipVia.code,
          description: shipVia.description,
        };
        simpleAutoCompleteList.push(shipViaBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      shipViaPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  poIntransitOnChange = (e) => {
    let purchaseOrderInTransitNumber = e.target.value;
    this.state.isShowAutoCompletePoIntransitList = true;
    let tempCriteria = this.state.purchaseOrderReceiptData;
    let showAutoCompleteList = this.state.isShowAutoCompletePoIntransitList;
    if (isEmpty(purchaseOrderInTransitNumber)) {
      this.state.isShowAutoCompletePoIntransitList = false;
      let showAutoCompleteList = this.state.isShowAutoCompletePoIntransitList;
      let tempCriteria = this.state.purchaseOrderReceiptData;
      tempCriteria.purchaseOrderInTransitNumber = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        purchaseOrderReceiptData: tempCriteria,
        poIntransitPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "purchaseOrderInTransitNumber" &&
      showAutoCompleteList === true &&
      purchaseOrderInTransitNumber !== ""
    ) {
      this.readPOIntransitBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value.toUpperCase();
    this.setState({ purchaseOrderReceiptData: tempCriteria });
  };
  poIntransitEnterKeyEventHandler = (e) => {
    let purchaseOrderInTransitNumber = e.target.value;
    this.readPurchaseInTransit(purchaseOrderInTransitNumber);
    this.state.isShowAutoCompletePoIntransitList = false;
    let showAutoCompleteList = this.state.isShowAutoCompletePoIntransitList;
    this.setState({
      poIntransitPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayPOIntransitAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompletePoIntransitList: isShowAutoCompleteList,
    });
  };
  getHeaderView() {
    return (
      <PurchaseOrderReceiptForm
        {...this.state}
        back={this.back}
        save={this.save}
        clearError={this.clearError}
        savePurchaseOrderReceipt={this.savePurchaseOrderReceipt}
        onChange={this.onChange}
        onPurchaseOrderChange={this.onPurchaseOrderChange}
        purchaseOrderEnterKeyEventHandler={
          this.purchaseOrderEnterKeyEventHandler
        }
        displayAutoCompletePurchaseOrderList={
          this.displayAutoCompletePurchaseOrderList
        }
        onDateChange={this.onDateChange}
        onVendorCodeChange={this.onVendorCodeChange}
        editPurchaseOrderReceiptLine={this.editPurchaseOrderReceiptLine}
        editPurchaseOrderReceiptRollLine={this.editPurchaseOrderReceiptRollLine}
        onPurchaseOrderReceiptLineChange={this.onPurchaseOrderReceiptLineChange}
        onPurchaseOrderReceiptRollLineChange={
          this.onPurchaseOrderReceiptRollLineChange
        }
        addOrUpdatePurchaseOrderReceiptRollLine={
          this.addOrUpdatePurchaseOrderReceiptRollLine
        }
        addOrUpdatePurchaseOrderReceiptLine={
          this.addOrUpdatePurchaseOrderReceiptLine
        }
        addNewRollLine={this.addNewRollLine}
        getPurchaseOrderLinesDatasFromExcel={
          this.getPurchaseOrderLinesDatasFromExcel
        }
        uploadExcelFile={this.uploadExcelFile}
        cancelPurchaseReceiptLine={this.cancelPurchaseReceiptLine}
        closePoReceiptLinePopup={this.closePoReceiptLinePopup}
        displayCancelErrorMsg={this.displayCancelErrorMsg}
        readPurchaseOrder={this.readPurchaseOrder}
        loadReceiptLines={this.loadReceiptLines}
        alertMsgList={this.state.alertMessage}
        alertErrorType={this.state.alertType}
        isShowAlert={this.state.isShowAlert}
        hideAlertCallBack={this.hideAlertCallBack}
        closeRollLineCallBack={this.closeRollLineCallBack}
        deleteReceiptRollLine={this.deleteReceiptRollLine}
        openLinePopup={this.openLinePopup}
        closeAlertModalCallBack={this.closeAlertModalCallBack}
        hidePopupAlertCallBack={this.hidePopupAlertCallBack}
        hideAlertCallBacklvl1={this.hideAlertCallBacklvl1}
        hideAlertCallBacklvl5={this.hideAlertCallBacklvl5}
        onLineChange={this.onLineChange}
        lnkPOModule={this.lnkPOModule}
        lnkPOIntransitModule={this.lnkPOIntransitModule}
        closePoIntransitModalCallBack={this.closePoIntransitModalCallBack}
        closeModalCallBack={this.closeModalCallBack}
        showLinePopup={this.showLinePopup}
        closeLinePopup={this.closeLinePopup}
        rollLineLocationOnChange={this.rollLineLocationOnChange}
        rollLineLocationEnterKeyEventHandler={
          this.rollLineLocationEnterKeyEventHandler
        }
        displayRollLineLocationAutoCompleteList={
          this.displayRollLineLocationAutoCompleteList
        }
        wareHouses={this.state.wareHouses}
        locationOnChange={this.locationOnChange}
        locationEnterKeyEventHandler={this.locationEnterKeyEventHandler}
        displayLocationAutoCompleteList={this.displayLocationAutoCompleteList}
        fobCityOnChange={this.fobCityOnChange}
        fobCityEnterKeyEventHandler={this.fobCityEnterKeyEventHandler}
        displayFobCityAutoCompleteList={this.displayFobCityAutoCompleteList}
        shipmentTermOnChange={this.shipmentTermOnChange}
        shipmentTermEnterKeyEventHandler={this.shipmentTermEnterKeyEventHandler}
        displayShipmentTermAutoCompleteList={
          this.displayShipmentTermAutoCompleteList
        }
        shipViaOnChange={this.shipViaOnChange}
        shipViaEnterKeyEventHandler={this.shipViaEnterKeyEventHandler}
        displayShipViaAutoCompleteList={this.displayShipViaAutoCompleteList}
        poIntransitOnChange={this.poIntransitOnChange}
        poIntransitEnterKeyEventHandler={this.poIntransitEnterKeyEventHandler}
        displayPOIntransitAutoCompleteList={
          this.displayPOIntransitAutoCompleteList
        }
        poReceiptRollLinesList={this.state.poReceiptRollLinesList}
        clearRollLineDetails={this.clearRollLineDetails}
      />
    );
  }
  getPurchaseReceiptHistory() {
    return (
      <PurchaseOrderReceiptHistoryDetailsForm
        {...this.state}
        purchaseOrderReceiptData={this.state.purchaseOrderReceiptData}
      />
    );
  }
  getModuleListView = () => {
    let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
    if (purchaseOrderReceiptData.code === NEW_ENTRY) {
      this.closeEntryForm();
      this.loadPurchaseOrderReceiptPage();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode)
          this.unlockPurchaseOrderReceipt(purchaseOrderReceiptData.code);
      } else {
        this.isLocked = false;
      }

      this.closeEntryForm();
      this.loadPurchaseOrderReceiptPage();
    }
  };
  resetView = () => {
    let purchaseReceiptData = this.state.purchaseOrderReceiptData;
    this.state.isReseted = true;
    if (this.isLocked) {
      this.isLocked = false;
      if (!this.state.isViewMode)
        this.unlockPurchaseOrderReceipt(purchaseReceiptData.code);
    } else {
      this.isLocked = false;
    }
    let purchaseOrderReceiptData = new PurchaseOrderReceiptBean();
    this.setState({
      purchaseOrderReceiptData: purchaseOrderReceiptData,
      isResetModule: true,
      moduleKeyCode: NEW_ENTRY,
      disabled: false,
      isFocus: false,
      isFocusLookup: true,
      isShowPORButton: true,
      isDisablePoIntransit: false,
    });
    this.state.moduleKeyCode = NEW_ENTRY;
    this.code = NEW_ENTRY;
    this.state.isViewMode = false;
    this.hideAlertCallBack();
    this.addNewEntry();
  };
  onModuleKeyCodeChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value;
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  onModuleKeyCodeWithCriteriaOnChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== NEW_ENTRY && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value.toUpperCase();
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  selectButtonClick = (e) => {
    this.editPurchaseOrderReceipt(this.state.moduleKeyCode);
    // this.disable();
  };
  disable = () => {
    this.setState({
      disabled: true,
    });
  };
  getCriteriaString = () => {
    let criteriaString = "";
    let moduleCaption = this.moduleCaption;
    if (this.state.criteria == null) {
      return <div />;
    } else {
      if (!isEmptyString(this.state.criteria.purchaseOrderReceiptNumber))
        criteriaString =
          criteriaString +
          moduleCaption +
          "PR# : " +
          this.state.criteria.purchaseOrderReceiptNumber +
          " ; ";
      if (
        !isEmptyString(this.state.criteria.purchaseOrderReceiptNumberStartsWith)
      )
        criteriaString =
          criteriaString +
          moduleCaption +
          "purchaseOrderReceiptNumberStartsWith : " +
          this.state.criteria.purchaseOrderReceiptNumberStartsWith +
          " ; ";
      if (
        !isEmptyString(this.state.criteria.purchaseOrderReceiptNumberContains)
      )
        criteriaString =
          criteriaString +
          moduleCaption +
          "purchaseOrderReceiptNumberContains: " +
          this.state.criteria.purchaseOrderReceiptNumberContains +
          " ; ";

      if (!isEmptyString(this.state.criteria.vendorCode))
        criteriaString =
          criteriaString +
          "vendorCode : " +
          this.state.criteria.vendorCode +
          " ; ";
      if (!isEmptyString(this.state.criteria.vendorName))
        criteriaString =
          criteriaString +
          "vendorName : " +
          this.state.criteria.vendorName +
          " ; ";
    }
    return <div>{criteriaString}</div>;
  };
  moduleExit = () => {
    let purchaseReceiptData = this.state.purchaseOrderReceiptData;
    if (purchaseReceiptData.code === NEW_ENTRY) {
      this.props.onModuleExit();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode)
          this.unlockPurchaseOrderReceipt(purchaseReceiptData.code);
      } else {
        this.isLocked = false;
      }
      this.props.onModuleExit();
    }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed });
  };
  hideAlertCallBacklvl1 = (msgType, isDisplayed) => {
    this.setState({ isShowPopupAlertlvl1: isDisplayed });
  };
  hideAlertCallBacklvl2 = (msgType, isDisplayed) => {
    this.setState({ isShowPopupAlertlvl2: isDisplayed });
  };
  hideAlertCallBacklvl5 = (msgType, isDisplayed) => {
    this.setState({ isShowPopupAlertlvl5: isDisplayed });
  };
  generateExcel = (e) => {
    if (e.detail == 1) {
      this.setState({
        isLoading: true,
        loadingText: "Generating Excel",
      });
      this.downloadReport(2, this.state.purchaseOrderReceiptData.code);
    }
  };
  generatePDF = () => {
    this.setState({
      isLoading: true,
      loadingText: "Generating PDF",
    });
    this.downloadReport(1, this.state.purchaseOrderReceiptData.code);
  };
  downloadReportResponse = (response) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
  };
  downloadReportError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
    ShowError("Error : " + error);
  };
  downloadReport = (reportType, code) => {
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let requestInput = new PurchaseOrderReceiptPrintRequest();
    requestInput.companyCode = this.companyCode;
    requestInput.purchaseOrderReceiptNumber = code;
    requestInput.input = reportBean;
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.PurchaseOrderReceiptMaintenancePDFReport_IsAccessible()
      ) {
        ReportService.generatePurchaseOrderReceiptPrintReport(
          requestInput,
          this.downloadReportResponse,
          this.downloadReportError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.PurchaseOrderReceiptMaintenanceExcelReport_IsAccessible()
      ) {
        ReportService.generatePurchaseOrderReceiptPrintReport(
          requestInput,
          this.downloadReportResponse,
          this.downloadReportError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  closeAlertProgressBarModalCallBack = (isShowPopup) => {
    this.setState({
      isShowProgressBarPopup: isShowPopup,
    });
  };
  displayCancelErrorMsg = () => {
    let errList = [];
    let errmsg = "Already Existing Line";
    errList.push(errmsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
    });
  };
  loadReceiptLines = () => {
    let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
    purchaseOrderReceiptData.lines = [];
    this.setState({
      purchaseOrderReceiptData: purchaseOrderReceiptData,
    });
    if (!isEmptyString(purchaseOrderReceiptData.purchaseOrderNumber)) {
      this.readPurchaseOrder(purchaseOrderReceiptData.purchaseOrderNumber);
    }
  };
  closeRollLineCallBack = (closeRollLineCallBack) => {
    this.setState({
      isDisableRollLine: false,
      disableFormFields: false,
      isShowLinePopup: false,
    });
  };
  /********** New 16/8/22 *********/
  openLinePopup = () => {
    this.setState({ isShowPopup: true });
  };
  hidePopupAlertCallBack = (msgType, isDisplayed) => {
    this.setState({
      isShowPopupAlert: isDisplayed,
    });
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.state.poReceiptRollLinesList = [];
    this.setReceiptDataValues();
    this.setState({
      isShowPopup: isShowPopup,
      isShowPopupAlert: isShowPopup,
      isShowPopupAlertlvl1: isShowPopup,
      isShowPopupAlertlvl5: isShowPopup,
    });
  };
  closeAlertModalCallBacklvl2 = (isShowPopup) => {
    this.setState({
      invoiceServiceLineList: [],
      isShowCreateInvoicePopup: isShowPopup,
      isShowPopupAlertlvl2: isShowPopup,
    });
  };
  setReceiptDataValues = () => {
    let receiptLineData = this.state.purchaseOrderReceiptLineData;
    let receivedQty = 0;
    receiptLineData.receiptRollLines.map((ln) => {
      receivedQty += parseFloat(ln.receivedQuantity);
    });
    receiptLineData.receivedQuantity = receivedQty.toFixed(2);
    receiptLineData.totalRolls = receiptLineData.receiptRollLines.length;
    this.setState({
      purchaseOrderReceiptLineData: receiptLineData,
    });
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let purchaseOrderReceiptList = this.state.purchaseOrderReceiptListData;
    if (sortField && !isEmptyArray(purchaseOrderReceiptList)) {
      const sorted = [...purchaseOrderReceiptList].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ purchaseOrderReceiptListData: sorted });
    }
  };
  createInvoiceError = (error) => {
    ShowError("Error : " + error);
  };
  clearRollLineDetails = () => {
    let rollData = new PurchaseOrderReceiptRollLineBean();
    this.setState({ purchaseOrderReceiptRollLineData: rollData });
    this.addNewRollLine();
  };
  openCreateInvoicePopup = (e) => {
    if (e.detail == 1) this.setState({ isShowCreateInvoicePopup: true });
  };
  createInvoiceResponse = (response) => {
    if (response.data != null && response.data.invoice != null) {
      this.handleResponse(response.data);
    }
  };
  createInvoiceFromPO = (e) => {
    if (e.detail == 1) {
      let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
      let serviceLines = this.state.invoiceServiceLineList;
      let request = new PurchaseReceiptToInvoiceInputBean();
      request.purchaseReceipts = purchaseOrderReceiptData;
      request.serviceLines = serviceLines;
      if (
        SecurityAccessManager.PurchaseOrderReceiptMaintenance_IsAccessible()
      ) {
        PurchaseOrderReceiptService.createInvoiceFromPurchaseOrderReceipt(
          request,
          this.createInvoiceResponse,
          this.createInvoiceError
        );
      } else {
        let errMsg = "Access Denied";
        let errList = [];
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
      this.closeAlertModalCallBacklvl2(false);
    }
  };
  getLineNumber = () => {
    let maxLineNumber = 0;
    let invoiceServiceLineList = this.state.invoiceServiceLineList;
    if (!isEmptyArray(invoiceServiceLineList)) {
      invoiceServiceLineList.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    }
    return maxLineNumber;
  };
  validate = (data) => {
    let isValid = false;
    let err_list = [];
    let errorMessage = "";
    if (data == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(data.serviceCode)) {
        let errMsg = "ServiceCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.amount)) {
        let errMsg = "Amount is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.uomCode)) {
        let errMsg = "UomCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.unitPrice)) {
        let errMsg = "Price is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(data.quantity)) {
        let errMsg = "Qty is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValid = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowPopupAlertlvl2: true,
      });
    } else {
      isValid = true;
    }
    return isValid;
  };
  addLines = (e) => {
    if (e.detail == 1) {
      let invoiceServiceLineList = this.state.invoiceServiceLineList;
      let invoiceServiceLineData = this.state.invoiceServiceLineData;
      invoiceServiceLineData.companyCode = this.companyCode;
      // invoiceServiceLineData.companyCode = "3PL";
      let isValid = false;
      isValid = this.validate(invoiceServiceLineData);

      if (isValid) {
        var lineNumber = this.getLineNumber();
        let isLineFound = false;
        if (!isEmptyArray(invoiceServiceLineList)) {
          invoiceServiceLineList.map((ln, i) => {
            if (ln.lineNumber == invoiceServiceLineData.lineNumber) {
              invoiceServiceLineData.isFetched = ln.isFetched;
              invoiceServiceLineList[i] = invoiceServiceLineData;
              isLineFound = true;
            }
          });
        }
        if (!isLineFound) {
          invoiceServiceLineData.lineNumber = ++lineNumber;
          invoiceServiceLineList.push(invoiceServiceLineData);
        }
        this.setState({
          invoiceServiceLineList: invoiceServiceLineList,
        });
        this.clearLines(e);
      }
    }
  };
  clearLines = (e) => {
    if (e.detail == 1) {
      let invoiceServiceLineData = new InvoiceServiceLineBean();
      this.setState({ invoiceServiceLineData: invoiceServiceLineData });
    }
  };
  reArrangeLines = (lineList) => {
    let maxLineNumber = 0;
    lineList.map((line) => {
      ++maxLineNumber;
      line.lineNumber = maxLineNumber;
    });
  };
  deleteService = (e, rowData) => {
    if (e.detail == 1) {
      let invoiceServiceLineList = this.state.invoiceServiceLineList;
      var index = invoiceServiceLineList.indexOf(rowData);
      if (index > -1) {
        invoiceServiceLineList.splice(index, 1);
        this.reArrangeLines(invoiceServiceLineList);
        this.setState({ invoiceServiceLineList: invoiceServiceLineList });
      }
    }
  };
  editService = (e, data, rowData) => {
    if (e.detail == 1) {
      let invoiceServiceLineData = new InvoiceServiceLineBean();
      let purchaseOrderReceiptData = this.state.purchaseOrderReceiptData;
      invoiceServiceLineData = { ...rowData };
      invoiceServiceLineData.companyCode = purchaseOrderReceiptData.companyCode;
      this.setState({ invoiceServiceLineData: invoiceServiceLineData });
    }
  };
  serviceLineOnchange = (e) => {
    let invoiceServiceLineData = this.state.invoiceServiceLineData;
    invoiceServiceLineData[e.target.name] = e.target.value;
    if (e.target.name == "quantity") {
      invoiceServiceLineData.amount =
        invoiceServiceLineData.unitPrice * e.target.value;
    }
    this.setState({ invoiceServiceLineData: invoiceServiceLineData });
  };

  /******* Reason AutoComplete ****** */

  invoiceUomOnChange = (e) => {
    let uomCode = e.target.value;
    this.state.isShowAutoCompleteInvoiceUomList = true;
    let tempData = this.state.invoiceServiceLineData;
    let showAutoCompleteList = this.state.isShowAutoCompleteInvoiceUomList;
    if (isEmpty(uomCode)) {
      this.state.isShowAutoCompleteInvoiceUomList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteInvoiceUomList;
      let tempData = this.state.invoiceServiceLineData;
      tempData.uomCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteInvoiceUomList: showAutoCompleteList,
        invoiceServiceLineData: tempData,
        invoiceUomPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "uomCode" &&
      showAutoCompleteList === true &&
      uomCode !== ""
    ) {
      this.readInvoiceUomBySearchString(e.target.value);
      this.readInvoiceUom(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ serviceDetail: tempData });
  };
  invoiceUomEnterKeyEvent = (e) => {
    this.readInvoiceUom(e.target.value);
    this.state.isShowAutoCompleteInvoiceUomList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteInvoiceUomList;
    this.setState({
      invoiceUomPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteInvoiceUomList: showAutoCompleteList,
    });
  };
  displayInvoiceUomAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteInvoiceUomList: isShowAutoCompleteList,
    });
  };
  readInvoiceUomBySearchString = (searchString) => {
    let uomData = this.state.uoms;
    let simpleAutoCompleteList = new Array();
    if (uomData.length > 0 && uomData != null) {
      uomData.map((obj) => {
        let uomBean = {
          description: obj.description,
          code: obj.code,
        };
        simpleAutoCompleteList.push(uomBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      invoiceUomPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readInvoiceUom = (uomCode) => {
    let tempData = this.state.invoiceServiceLineData;
    let uomBean = null;
    let uomData = null;
    this.state.uoms.map((ln) => {
      if (ln.code === uomCode) {
        uomBean = ln;
        uomData = new BaseBean();
        uomData.code = ln.code;
        uomData.description = ln.description;
      }
    });
    if (!isEmpty(uomBean)) {
      tempData.uomCode = uomBean.code;
      this.state.isShowAutoCompleteInvoiceUomList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteInvoiceUomList;
      this.setState({
        serviceDetail: tempData,
        isShowAutoCompleteInvoiceUomList: showAutoCompleteList,
      });
    }
  };

  serviceOnChange = (e) => {
    let serviceCode = e.target.value;
    this.state.isShowAutoCompleteServiceList = true;
    let tempData = this.state.invoiceServiceLineData;
    let showAutoCompleteList = this.state.isShowAutoCompleteServiceList;
    if (isEmpty(serviceCode)) {
      this.state.isShowAutoCompleteServiceList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteServiceList;
      let tempData = this.state.invoiceServiceLineData;
      tempData.serviceCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteServiceList: showAutoCompleteList,
        invoiceServiceLineData: tempData,
        servicePageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "serviceCode" &&
      showAutoCompleteList === true &&
      serviceCode !== ""
    ) {
      this.readServiceBySearchString(e.target.value);
      this.readService(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ invoiceServiceLineData: tempData });
  };
  serviceEnterKeyEvent = (e) => {
    this.readService(e.target.value);
    this.state.isShowAutoCompleteServiceList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteServiceList;
    this.setState({
      servicePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteServiceList: showAutoCompleteList,
    });
  };
  displayServiceAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteServiceList: isShowAutoCompleteList,
    });
  };
  readServiceBySearchString = (searchString) => {
    let serviceData = this.state.services;
    let simpleAutoCompleteList = new Array();
    if (serviceData.length > 0 && serviceData != null) {
      serviceData.map((obj) => {
        let serivceBean = {
          description: obj.description,
          code: obj.code,
        };
        simpleAutoCompleteList.push(serivceBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      servicePageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readService = (serviceCode) => {
    let tempData = this.state.invoiceServiceLineData;
    let serivceBean = null;
    let serviceData = null;
    this.state.services.map((ln) => {
      if (ln.code === serviceCode) {
        serivceBean = ln;
        serviceData = new BaseBean();
        serviceData.code = ln.code;
        serviceData.description = ln.description;
      }
    });
    if (!isEmpty(serivceBean)) {
      tempData.serviceCode = serivceBean.code;
      tempData.serviceName = serivceBean.description;
      tempData.uomCode = serivceBean.uomCode;
      tempData.unitPrice = serivceBean.price;
      this.state.isShowAutoCompleteServiceList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteServiceList;
      this.setState({
        invoiceServiceLineData: tempData,
        isShowAutoCompleteServiceList: showAutoCompleteList,
      });
    }
  };
  render() {
    let moduleOrderStatus = this.state.moduleOrderStatus;
    let invoiceServiceLineList = this.state.invoiceServiceLineList;
    let serviceDetail = this.state.invoiceServiceLineData;
    return (
      <div>
        <ProgressBar
          closeAlertModalCallBack={this.closeAlertProgressBarModalCallBack}
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <ReasonCaptureComponent
          ref={this.receiptLineCancelReasonDialogRef}
          reasons={this.state.cancelReasons}
          reasonData={this.state.reasonData}
          title="Receipt Line Cancel Reason"
          onChange={this.onReasonChange}
          onClick={this.onLineCancelReasonContinue}
          isShowPopup={this.state.isShowLineCancelReasonPopup}
          closeReasonModelCallBack={this.closeReasonModelCallBack}
          reasonEnterKeyEventHandler={this.reasonEnterKeyEventHandler}
          reasonPageListForAutoCompleteList={
            this.state.reasonPageListForAutoCompleteList
          }
          displayAutoCompleteReasonList={this.displayAutoCompleteReasonList}
          showAutoCompleteReasonList={this.state.showAutoCompleteReasonList}
          onReasonDescChange={this.onReasonDescChange}
        />
        <ReasonCaptureComponent
          ref={this.rollLineCancelReasonDialogRef}
          reasons={this.state.cancelReasons}
          reasonData={this.state.reasonData}
          title="Receipt Roll Line Cancel"
          onChange={this.onReasonChange}
          onClick={this.onRollLineCancelReasonContinue}
          isShowPopup={this.state.isShowRollLineCancelReasonPopup}
          closeReasonModelCallBack={this.closeReasonModelCallBack}
          reasonEnterKeyEventHandler={this.reasonEnterKeyEventHandler}
          reasonPageListForAutoCompleteList={
            this.state.reasonPageListForAutoCompleteList
          }
          displayAutoCompleteReasonList={this.displayAutoCompleteReasonList}
          showAutoCompleteReasonList={this.state.showAutoCompleteReasonList}
          onReasonDescChange={this.onReasonDescChange}
        />
        {this.state.isSpecialViewMode == false ? (
          <AlertToolBox
            alertMsgList={this.state.alertMessage}
            alertErrorType={this.state.alertType}
            isShowAlert={this.state.isShowAlert}
            hideAlertCallBack={this.hideAlertCallBack}
          />
        ) : null}
        <ModuleToolBar
          isShowNewButton={false}
          onNewEntry={() => this.addNewEntry()}
          onModuleExit={() => this.moduleExit()}
          resetView={() => this.resetView()}
          pageTitle={this.state.pageTitle}
          loadingText={this.state.loadingText}
          isLoading={this.state.isLoading}
          isShowModuleSearchContainer={this.state.isShowModuleSearchContainer}
          isMaintenanceMode={this.state.isMaintenanceMode}
          onModuleKeyContainerButtonClick={this.editPurchaseOrderReceipt}
          moduleKeyCode={this.state.moduleKeyCode}
          onModuleKeyCodeChange={this.onModuleKeyCodeChange}
          getModuleListView={this.getModuleListView}
          lookupRequired={true} //for f2 lookup
          lookupHandler={this.state.purchaseOrderReceiptLookupHandler} //for f2 lookup
          showCriteriaDialog={true} //for f2 lookup
          onModuleKeyCodeWithCriteriaOnChange={
            this.onModuleKeyCodeWithCriteriaOnChange
          }
          selectButtonClick={this.selectButtonClick}
          disabled={this.state.disabled}
          isSpecialViewMode={this.state.isSpecialViewMode}
          isResetView={this.state.isResetView}
          isFocusLookup={this.state.isFocusLookup}
        />
        {!this.state.isPurchaseOrderReceiptListFormOpen &&
          this.state.isSpecialViewMode == false &&
          this.state.isViewMode == false && (
            <BaseToolBar
              pageTitle={this.state.pageTitle}
              back={this.back}
              save={this.save}
              isShowSaveButton={this.state.isShowSaveButton}
              clearError={this.clearError}
              isShowClearErrorButton={this.state.isShowClearErrorButton}
              //generatePDF={this.generatePDF}
              // isShowPDFButton={this.state.isShowPDFReportButton}
              extend_toolbar={
                <>
                  {/* {this.state.isShowExcelButton && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.generateExcel(e)}
                    >
                      Excel
                    </Button>
                  )} */}
                  {this.state.isShowApproveButton && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.approvePurchaseOrderReceipt(e)}
                    >
                      Approve
                    </Button>
                  )}
                  {this.state.isShowCancelButton && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.cancelPurchaseOrderReceipt(e)}
                    >
                      Cancel
                    </Button>
                  )}
                  {this.state.isShowCreateInvoiceButton && this.state.is3PL && (
                    <Button
                      className="header_buttons secondary"
                      size="sm"
                      onClick={(e) => this.openCreateInvoicePopup(e)}
                    >
                      CreateInvoice
                    </Button>
                  )}
                </>
              }
            />
          )}

        {this.state.isShowNodes && (
          <BaseNodeBar
            nodeList={this.state.nodeList}
            selectedModuleKey={this.state.selectedNodeKey}
            nodeOnSelect={this.nodeOnSelect}
            moduleStatus={moduleOrderStatus}
          />
        )}
        {!this.state.isShowNodes &&
          !this.state.isPurchaseOrderReceiptListFormOpen &&
          !this.state.isPurchaseOrderReceiptHistoryFormOpen &&
          this.state.isPurchaseOrderReceiptEntryFormOpen &&
          this.getHeaderView()}
        {this.state.isShowNodes &&
          !this.state.isPurchaseOrderReceiptListFormOpen &&
          this.state.isPurchaseOrderReceiptEntryFormOpen &&
          !this.state.isPurchaseOrderReceiptHistoryFormOpen &&
          this.getHeaderView()}
        {this.state.isShowNodes &&
          !this.state.isPurchaseOrderReceiptListFormOpen &&
          !this.state.isPurchaseOrderReceiptEntryFormOpen &&
          this.state.isPurchaseOrderReceiptHistoryFormOpen &&
          this.getPurchaseReceiptHistory()}
        {this.state.isPurchaseOrderReceiptListFormOpen &&
          this.state.isSpecialViewMode == false && (
            <PurchaseOrderReceiptListForm
              {...this.state}
              filterPurchaseOrder={this.filterPurchaseOrder}
              loadFirst={this.loadFirst}
              loadNext={this.loadNext}
              loadPrevious={this.loadPrevious}
              loadLast={this.loadLast}
              editPurchaseOrderReceipt={this.editPurchaseOrderReceipt}
              onChange={this.onCriteriaChange}
              resetfilteredPurchaseOrder={this.resetfilteredPurchaseOrder}
              handleSortingChange={this.handleSortingChange}
            />
          )}
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowCreateInvoicePopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel2"}
          closeAlertModalCallBack={this.closeAlertModalCallBacklvl2}
          title={"SERVICE DETAILS ENTRY"}
          lineFunctionalityForm={this.lineFunctionalityForm}
          closeOnDocumentClick={false}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowPopupAlertlvl2}
              hideAlertCallBack={this.hideAlertCallBacklvl2}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons"
                size="sm"
                onClick={(e) => this.createInvoiceFromPO(e)}
              >
                Continue
              </Button>
            </div>
          }
          content={
            <div>
              <Row>
                <Col className="align-items-left" sm="2">
                  {" "}
                  <FormLabel>CompanyCode</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="companyCode"
                    readOnly={true}
                    value={this.state.purchaseOrderReceiptData.companyCode}
                    disabled={true}
                  />{" "}
                </Col>
                <Col className="align-items-left" sm="1">
                  {" "}
                  <FormLabel>PR#</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="code"
                    readOnly={true}
                    value={this.state.purchaseOrderReceiptData.code}
                    disabled={true}
                  />{" "}
                </Col>
              </Row>
              <Row>
                <Col className="align-items-left" sm="2">
                  <FormLabel>Service Details</FormLabel>
                </Col>
              </Row>
              <div className="div_Custom_1">
                <Table id="fabrics_tables_default">
                  <thead>
                    <tr>
                      <th>Line#</th>
                      <th>Service</th>
                      <th>Description</th>
                      <th>Uom</th>
                      <th>Qty</th>
                      <th>Price</th>
                      <th>Amount</th>
                      <th></th>
                    </tr>
                  </thead>
                  {invoiceServiceLineList != null ? (
                    <tbody>
                      {invoiceServiceLineList.map((ln, index) => (
                        <tr key={index}>
                          <td className="hyperLinkText">
                            <Button
                              variant="secondry"
                              className="hyperLinkText"
                              onClick={(e) =>
                                this.editService(e, ln.lineNumber, ln)
                              }
                            >
                              {ln.lineNumber}
                            </Button>
                          </td>
                          <td>{ln.serviceCode}</td>
                          <td>{ln.serviceName}</td>
                          <td>{ln.uomCode}</td>
                          <td>{ln.quantity}</td>
                          <td>{ln.unitPrice}</td>
                          <td>{ln.amount}</td>
                          <td>
                            {!ln.isFetched &&
                              this.state.isDisableButtons != true && (
                                <Button
                                  size="sm"
                                  onClick={(e) => this.deleteService(e, ln)}
                                >
                                  <DeleteIcon />
                                </Button>
                              )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  ) : null}
                </Table>
                {invoiceServiceLineList.length != 0 ? null : (
                  <div className="no_Data">{"NO DATA"}</div>
                )}
              </div>
              <Row>
                <Col className="align-items-left" sm="">
                  <FormLabel>Service Line Detail</FormLabel>
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  {" "}
                  <FormLabel>Ln#</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="lineNumber"
                    type="text"
                    onChange={this.serviceLineOnchange}
                    readOnly={true}
                    value={serviceDetail.lineNumber}
                    disabled={true}
                  />{" "}
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>Service</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    onChange={this.serviceOnChange}
                    placeholder="serviceCode"
                    name="serviceCode"
                    value={serviceDetail.serviceCode}
                    lookupRequired={true}
                    lookupHandler={this.state.serviceLookupHandler}
                    showCriteriaDialog={true}
                    enterKeyEventHandler={this.serviceEnterKeyEvent}
                    autoCompleteListData={
                      this.state.servicePageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayServiceAutoCompleteList
                    }
                    showAutoCompleteList={
                      this.state.isShowAutoCompleteServiceList
                    }
                    disabled={this.state.isDisabledFields}
                  />
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="serviceName"
                    type="text"
                    onChange={this.serviceLineOnchange}
                    readOnly={true}
                    value={serviceDetail.serviceName}
                    disabled={true}
                  />{" "}
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  {" "}
                  <FormLabel>UOM</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    onChange={this.serviceLineOnchange}
                    // placeholder="uomCode"
                    name="uomCode"
                    value={serviceDetail.uomCode}
                    // lookupRequired={true}
                    // lookupHandler={this.state.uomLookupHandler}
                    // showCriteriaDialog={true}
                    // enterKeyEventHandler={this.invoiceUomEnterKeyEvent}
                    // autoCompleteListData={
                    //   this.state.invoiceUomPageListForAutoCompleteList
                    // }
                    // enableAutoCompleteTextBox={true}
                    // displayAutoCompleteList={
                    //   this.displayInvoiceUomAutoCompleteList
                    // }
                    // showAutoCompleteList={
                    //   this.state.isShowAutoCompleteInvoiceUomList
                    // }
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>Price</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <NumberFormatInputbox
                    value={serviceDetail.unitPrice}
                    onChange={this.serviceLineOnchange}
                    className=" text-right"
                    decimalScale={2}
                    name={"unitPrice"}
                    // readOnly = {true}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>Qty</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <NumberFormatInputbox
                    value={serviceDetail.quantity}
                    onChange={this.serviceLineOnchange}
                    className=" text-right"
                    decimalScale={2}
                    name={"quantity"}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>Amount</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <NumberFormatInputbox
                    value={serviceDetail.amount}
                    onChange={this.serviceLineOnchange}
                    className="summary_input text-right"
                    decimalScale={2}
                    name={"amount"}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col className="text-center">
                  <Button
                    size="sm"
                    id="fabric_Add_Button"
                    className="header_buttons enterFocus"
                    onClick={(e) => this.addLines(e)}
                  >
                    Add/Update
                  </Button>
                  <Button
                    id="fabric_Add_Button"
                    size="sm1"
                    onClick={(e) => this.clearLines(e)}
                  >
                    Clear
                  </Button>
                </Col>
              </Row>
            </div>
          }
        />
        <ReasonCaptureComponent
          ref={this.cancelReasonDialogRef}
          reasons={this.state.cancelReasons}
          reasonData={this.state.reasonData}
          title="PurchaseReceipt Cancel"
          onChange={this.onReasonChange}
          onClick={this.onCancelReasonContinue}
          isShowPopup={this.state.isShowCancelReasonPopup}
          closeReasonModelCallBack={this.closeReasonModelCallBack}
          reasonEnterKeyEventHandler={this.reasonEnterKeyEventHandler}
          reasonPageListForAutoCompleteList={
            this.state.reasonPageListForAutoCompleteList
          }
          displayAutoCompleteReasonList={this.displayAutoCompleteReasonList}
          showAutoCompleteReasonList={this.state.showAutoCompleteReasonList}
          onReasonDescChange={this.onReasonDescChange}
        />
      </div>
    );
  }
}
class PurchaseOrderReceiptListForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      criteria: new PurchaseOrderReceiptSearchCriteria(),
      filter: "",
      pageList: this.props.pageList,
    };
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  filterPurchaseOrder = (e) => {
    if (e.detail == 1) this.props.filterPurchaseOrder();
  };
  resetfilteredPurchaseOrder = (e) => {
    if (e.detail == 1) {
      let criteria = this.props.criteria;

      this.props.resetfilteredPurchaseOrder(criteria);
    }
  };
  loadFirst = (e) => {
    if (e.detail == 1) this.props.loadFirst();
  };
  loadNext = (e) => {
    if (e.detail == 1) this.props.loadNext();
  };
  loadPrevious = (e) => {
    if (e.detail == 1) this.props.loadPrevious();
  };
  loadLast = (e) => {
    if (e.detail == 1) this.props.loadLast();
  };
  handlePurchaseOrderCodeChange = (event) => {
    this.setState({ filter: event.target.value });
  };
  editPurchaseOrderReceipt = (e, val, row) => {
    if (e.detail == 1) this.props.editPurchaseOrderReceipt(val, false);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail == 1) this.props.handleSortingChange(accessor);
  };
  onKeyDown = (e) => {
    if (e.keyCode == 13) {
      this.props.filterPurchaseOrder();
    }
  };
     purchaseReceiptPageColumns = () => {
      const columns = new Array();
      columns.push(
        new ColumnDefinition()
          .setDetails("POReceipt#", "code", true)
          .setStyleDetails("left", "", "", "wt-3", "wt-3")
          .setClickDetails(true, false, this.editPurchaseOrderReceipt, null),
      );
            columns.push(
        new ColumnDefinition()
          .setDetails("Purchase Order", "purchaseOrderNumber", true)
          .setStyleDetails("left", "", "", "wt-3", "wt-3")
         
      );
      columns.push(
        new ColumnDefinition()
          .setDetails("Vendor", "vendorCode", true)
          .setStyleDetails("left", "", "", "wt-3", "wt-3"),
      );
      columns.push(
        new ColumnDefinition()
          .setDetails("VendorName", "vendorName", true)
          .setStyleDetails("left", "", "", "wt-3", "wt-3"),
      );
            columns.push(
        new ColumnDefinition()
          .setDetails("ReceiptDate", "receiptDate", true, false, true)
          .setStyleDetails("left", "", "", "wt-3", "wt-3"),
      );


      columns.push(
        new ColumnDefinition()
          .setDetails("Status", "receiptStatus", true)
          .setStyleDetails("left", "", "", "wt-3", "wt-3")
          .setStatusDetails(true, this.getCaption),
      );
      columns.push(
        new ColumnDefinition()
          .setDetails("ShipmentTerm", "shipmentTermsCode", true)
          .setStyleDetails("left", "", "", "wt-3", "wt-3"),

      );
            columns.push(
        new ColumnDefinition()
          .setDetails("Location", "locationCode", true)
          .setStyleDetails("left", "", "", "wt-3", "wt-3"),

      );

  
      return columns;
    };
    getCaption = (status) => {
      return ModuleUtils.getPurchaseOrderReceiptStatusCaption(status);
    };
  
  render() {
    let purchaseOrderReceiptList = new Array();
    if (!isEmptyArray(this.props.purchaseOrderReceiptListData))
      purchaseOrderReceiptList = this.props.purchaseOrderReceiptListData;
    let criteria = this.props.criteria;
    let pageList = this.props.pageList;
    let totalPages = 0;
    let pageSize = pageList.pageSize;
    let totalCount = pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    return (
      <div>
        <div className="secondary_module_header">
          {/* <div className="secondary_module_header_title">
            <FormLabel className="secondary_module_search_color">
              Search
            </FormLabel>
            <span className="secondary_module_header_title_2">
              <InputTextbox
                name="searchName"
                type="text"
                placeholder="Enter Value to Filter.."
                value={criteria.searchName}
                onChange={this.onChange}
                onKeyDown={this.onKeyDown}
              />
              <Button onClick={(e) => this.filterPurchaseOrder(e)}>
                Filter
              </Button>
              <Button onClick={(e) => this.resetfilteredPurchaseOrder(e)}>
                Reset
              </Button>
            </span>
          </div> */}
          <div className="mdle-criteria-wrap">
            <div className="">
              <FormLabel className="criteria-labl">Status</FormLabel>
            </div>
            <div className="criteria-val">
              <FormControl
                as="select"
                custom
                onChange={this.onChange}
                name="receiptStatus"
                value={criteria.receiptStatus}
              >
                <option value={""}>All</option>
                <option value={"A"}>Approved</option>
                <option value={"U"}>UnApproved</option>
                <option value={"X"}>Cancelled</option>
              </FormControl>
            </div>
            <div className="">
              <FormLabel className="criteria-labl">Search</FormLabel>
            </div>
            <div className="criteria-val">
              <InputTextbox
                name="searchName"
                type="text"
                placeholder="Enter Value to Filter.."
                value={criteria.searchName}
                onChange={this.onChange}
                onKeyDown={this.onKeyDown}
              />
            </div>
            <div className="criteria-btn-wrap ">
              <Button
                className="header_buttons secondary"
                size="sm"
                onClick={(e) => this.filterPurchaseOrder(e)}
              >
                Filter
              </Button>
              <Button
                className="header_buttons secondary"
                size="sm"
                onClick={(e) => this.resetfilteredPurchaseOrder(e)}
              >
                Reset
              </Button>
            </div>
          </div>
          <div className="module_header_secondary_buttons">
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadFirst(e)}
            >
              First
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadPrevious(e)}
            >
              Previous
            </Button>
            <span>
              PAGE - {pageList.currentPage} OF {parseInt(totalPages)}
            </span>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadNext(e)}
            >
              Next
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadLast(e)}
            >
              Last
            </Button>
          </div>
        </div>
        <div className="mt-3">
          <CustomTable
            data={purchaseOrderReceiptList}
            columns={this.purchaseReceiptPageColumns()}
            enableHighlight={true} // Boolean flag controlling highlight execution
            //  searchText={pickTicketCriteria.searchName} // Search input text
          />
        </div>
      </div>
    );
  }
}
class PurchaseOrderReceiptForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      //
    };
    this.purchaseOrderRef = React.createRef();
    this.fobCityRef = React.createRef();
    this.warehouseRef = React.createRef();
    this.paymentTermRef = React.createRef();
    this.shipmentTermRef = React.createRef();
    this.shipViaRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.initLookupHandlers();
    this.setInputFocus();
  }
  setInputFocus = () => {
    if (this.props.moduleKeyCode === NEW_ENTRY) {
      this.purchaseOrderRef.current.focus();
    }
  };
  initLookupHandlers = () => {
    let intStatus = "A";
    let poStatus = "A";
    let purchaseOrderNumber =
      this.props.purchaseOrderReceiptData.purchaseOrderNumber;
    let paymentTermLookupHandler = new GenericAttributeLookupHandler(
      this.props.paymentTerms,
      "Payment Term"
    );
    this.setState({ paymentTermLookupHandler: paymentTermLookupHandler });
    let warehouseLookupHandler = new GenericAttributeLookupHandler(
      this.props.wareHouses,
      "Warehouse"
    );
    this.setState({ warehouseLookupHandler: warehouseLookupHandler });
    let shipmentTermLookupHandler = new GenericAttributeLookupHandler(
      this.props.shipmentTerms,
      "ShipmentTerms"
    );
    this.setState({ shipmentTermLookupHandler: shipmentTermLookupHandler });
    let fobCityLookupHandler = new GenericAttributeLookupHandler(
      this.props.fOBCities,
      "FobCity"
    );
    this.setState({ fobCityLookupHandler: fobCityLookupHandler });
    let shipViaLookupHandler = new GenericAttributeLookupHandler(
      this.props.shipVias,
      "ShipVia"
    );
    this.setState({ shipViaLookupHandler: shipViaLookupHandler });
    let purchaseOrderLookupHandler = new PurchaseOrderLookupHandler(
      this.companyCode,
      "Purchase Order",
      "",
      LogicConstants.PURCHASE_ORDER_APPROVE_STATUS
    );
    this.setState({ purchaseOrderLookupHandler: purchaseOrderLookupHandler });
  };
  closePurchaseOrderEntryForm() {
    this.props.closePurchaseOrderEntryForm();
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  onPurchaseOrderChange = (e) => {
    this.props.onPurchaseOrderChange(e);
  };
  purchaseOrderEnterKeyEventHandler = (e) => {
    this.props.purchaseOrderEnterKeyEventHandler(e);
  };
  displayAutoCompletePurchaseOrderList = (showAutoCompleteList) => {
    this.props.displayAutoCompletePurchaseOrderList(showAutoCompleteList);
  };
  onDateChange = (e) => {
    this.props.onDateChange(e);
  };
  onVendorCodeChange = (e) => {
    this.props.onVendorCodeChange(e);
  };
  showLookup = () => {
    this.props.openLinePopup();
  };
  closeLookup = () => {
    this.props.addOrUpdatePurchaseOrderReceiptLine();
  };
  addOrUpdatePurchaseOrderReceiptLine = (e) => {
    if (e.detail == 1) {
      this.props.addOrUpdatePurchaseOrderReceiptLine(e);
      this.props.closeAlertModalCallBack(false);
    }
  };
  editPurchaseOrderReceiptLine = (e, val, row) => {
    if (e.detail == 1) {
      this.props.editPurchaseOrderReceiptLine(val, row);
      this.showLookup();
    }
  };
  deleteReceiptLine = (e, rowData) => {
    if (e.detail == 1) this.cancelPurchaseReceiptLine(rowData);
  };
  cancelPurchaseReceiptLine = (receiptLineData) => {
    this.props.cancelPurchaseReceiptLine(receiptLineData);
  };
  editPurchaseOrderReceiptRollLine = (val, rowData) => {
    this.props.editPurchaseOrderReceiptRollLine(val, rowData);
  };
  onPurchaseOrderReceiptLineChange = (e) => {
    this.props.onPurchaseOrderReceiptLineChange(e);
  };
  onPurchaseOrderReceiptRollLineChange = (e) => {
    this.props.onPurchaseOrderReceiptRollLineChange(e);
  };
  addOrUpdatePurchaseOrderReceiptRollLine = (e) => {
    this.props.addOrUpdatePurchaseOrderReceiptRollLine(e);
  };
  addNewRollLine = (e) => {
    this.props.addNewRollLine(e);
  };
  getPurchaseOrderLinesDatasFromExcel = (e) => {
    this.props.getPurchaseOrderLinesDatasFromExcel(e);
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  uploadExcelFile = (e) => {
    this.props.uploadExcelFile(e);
  };
  onLineChange = (e) => {
    this.props.onLineChange(e);
  };
  lnkPOModule = (e) => {
    if (e.detail == 1) this.props.lnkPOModule();
  };
  lnkPOIntransitModule = (e) => {
    if (e.detail == 1) this.props.lnkPOIntransitModule();
  };
  closePoIntransitModalCallBack = (isOpen) => {
    this.props.closePoIntransitModalCallBack(isOpen);
  };
  closeModalCallBack = (isOpen) => {
    this.props.closeModalCallBack(isOpen);
  };
  loadReceiptLines = (e) => {
    if (e.detail <= 1) this.props.loadReceiptLines();
  };
  rollLineLocationOnChange = (e) => {
    this.props.rollLineLocationOnChange(e);
  };
  rollLineLocationEnterKeyEventHandler = (e) => {
    this.props.rollLineLocationEnterKeyEventHandler(e);
  };
  displayRollLineLocationAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayRollLineLocationAutoCompleteList(showAutoCompleteList);
  };
  locationOnChange = (e) => {
    this.props.locationOnChange(e);
  };
  locationEnterKeyEventHandler = (e) => {
    this.props.locationEnterKeyEventHandler(e);
  };
  displayLocationAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayLocationAutoCompleteList(showAutoCompleteList);
  };
  fobCityOnChange = (e) => {
    this.props.fobCityOnChange(e);
  };
  fobCityEnterKeyEventHandler = (e) => {
    this.props.fobCityEnterKeyEventHandler(e);
  };
  displayFobCityAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayFobCityAutoCompleteList(showAutoCompleteList);
  };
  shipmentTermOnChange = (e) => {
    this.props.shipmentTermOnChange(e);
  };
  shipmentTermEnterKeyEventHandler = (e) => {
    this.props.shipmentTermEnterKeyEventHandler(e);
  };
  displayShipmentTermAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayShipmentTermAutoCompleteList(showAutoCompleteList);
  };
  shipViaOnChange = (e) => {
    this.props.shipViaOnChange(e);
  };
  shipViaEnterKeyEventHandler = (e) => {
    this.props.shipViaEnterKeyEventHandler(e);
  };
  displayShipViaAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayShipViaAutoCompleteList(showAutoCompleteList);
  };
  poIntransitOnChange = (e) => {
    this.props.poIntransitOnChange(e);
  };
  poIntransitEnterKeyEventHandler = (e) => {
    this.props.poIntransitEnterKeyEventHandler(e);
  };
  displayPOIntransitAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayPOIntransitAutoCompleteList(showAutoCompleteList);
  };
  render() {
    let purchaseOrderReceiptData = new PurchaseOrderReceiptBean();
    purchaseOrderReceiptData = this.props.purchaseOrderReceiptData;
    let purchaseOrderReceiptLineData = this.props.purchaseOrderReceiptLineData;
    let purchaseOrderReceiptRollLineData =
      this.props.purchaseOrderReceiptRollLineData;
    let vendor_List = this.props.vendor_List;
    let disableFormFields = this.props.disableFormFields;
    let lines = [];
    if (purchaseOrderReceiptData != null) {
      lines = purchaseOrderReceiptData.lines;
    }
    if (!lines) {
      lines = new Array();
    }
    let isDisabledFields = this.props.isDisabledFields;
    const textAreaStyle = {
      maxHeight: "9em",
      width: "45em",
      resize: "none",
      padding: "9px",
      boxSizing: "border-box",
      fontSize: "12px",
    };
    let is3PL = this.props.is3PL;
    return (
      <div>
        <div>
          <MultiViewPopup
            isModulePopup={true}
            id="modulePopup"
            isShowPopup={this.props.isShowPurchaseOrderModule}
            closeModalCallBack={this.closeModalCallBack}
            module={this.props.moduleForPopup}
          ></MultiViewPopup>
          <MultiViewPopup
            isModulePopup={true}
            id="modulePopup"
            isShowPopup={this.props.isShowPurchaseOrderInTransitModule}
            closeModalCallBack={this.closePoIntransitModalCallBack}
            module={this.props.moduleForPopup}
          ></MultiViewPopup>
          <div>
            <MultiViewPopup
              isModulePopup={false}
              isShowPopup={this.props.isShowPopup}
              closeOnEsc={false}
              popupLvlClass={"popupSizeLevel1"}
              closeAlertModalCallBack={this.props.closeAlertModalCallBack}
              title={"LINE DETAIL"}
              closeOnDocumentClick={false}
              lineFunctionalityForm={this.lineFunctionalityForm}
              alertContainerBox={
                <AlertToolBox
                  alertMsgList={this.props.alertMessage}
                  alertErrorType={this.props.alertType}
                  isShowAlert={this.props.isShowPopupAlert}
                  hideAlertCallBack={this.props.hidePopupAlertCallBack}
                />
              }
              headerButtonContainer={
                <div className="floatLeft">
                  {this.props.isDisableButtons && (
                    <Button
                      className="header_buttons"
                      size="sm"
                      onClick={(e) =>
                        this.addOrUpdatePurchaseOrderReceiptLine(e)
                      }
                    >
                      Add/Update
                    </Button>
                  )}
                </div>
              }
              content={
                <div className="header_div">
                  <PurchaeOrderReceiptLinePopUpForm
                    is3PL={this.props.is3PL}
                    isDisableButtons={this.props.isDisableButtons}
                    disableFormFields={this.props.disableFormFields}
                    fabricStyle_List={this.props.fabricStyle_List}
                    purchaseOrderReceiptData={purchaseOrderReceiptData}
                    purchaseOrderReceiptLineData={purchaseOrderReceiptLineData}
                    purchaseOrderReceiptRollLineData={
                      purchaseOrderReceiptRollLineData
                    }
                    addOrUpdatePurchaseOrderReceiptRollLine={
                      this.addOrUpdatePurchaseOrderReceiptRollLine
                    }
                    onLineChange={this.onPurchaseOrderReceiptLineChange}
                    onRollLineChange={this.onPurchaseOrderReceiptRollLineChange}
                    editPurchaseOrderReceiptRollLine={
                      this.editPurchaseOrderReceiptRollLine
                    }
                    addNewRollLine={this.addNewRollLine}
                    getPurchaseOrderLinesDatasFromExcel={
                      this.getPurchaseOrderLinesDatasFromExcel
                    }
                    uploadExcelFile={this.uploadExcelFile}
                    poReceiptRollLinesList={this.props.poReceiptRollLinesList}
                    isDisableRollLine={this.props.isDisableRollLine}
                    closeRollLineCallBack={this.props.closeRollLineCallBack}
                    displayCancelErrorMsg={this.props.displayCancelErrorMsg}
                    deleteReceiptRollLine={this.props.deleteReceiptRollLine}
                    alertMessage={this.props.alertMessage}
                    alertType={this.props.alertType}
                    isShowPopupAlertlvl5={this.props.isShowPopupAlertlvl5}
                    hideAlertCallBacklvl5={this.props.hideAlertCallBacklvl5}
                    isShowLinePopup={this.props.isShowLinePopup}
                    showLinePopup={this.props.showLinePopup}
                    closeLinePopup={this.props.closeLinePopup}
                    rollLineLocationOnChange={this.rollLineLocationOnChange}
                    rollLineLocationEnterKeyEventHandler={
                      this.rollLineLocationEnterKeyEventHandler
                    }
                    displayRollLineLocationAutoCompleteList={
                      this.displayRollLineLocationAutoCompleteList
                    }
                    rollLineLocationPageListForAutoCompleteList={
                      this.props.rollLineLocationPageListForAutoCompleteList
                    }
                    isShowAutoCompleteRolllineLocationList={
                      this.props.isShowAutoCompleteRolllineLocationList
                    }
                    clearRollLineDetails={this.props.clearRollLineDetails}
                    wareHouses={this.props.wareHouses}
                  />
                </div>
              }
            />
          </div>
          <div className="header_div">
            <Row>
              <Col sm="1">
                {" "}
                <FormLabel>Date#</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <DatePickerComponent
                  name="createdDate"
                  value={purchaseOrderReceiptData.createdDate}
                  onChange={this.onChange}
                  disabled={true}
                />
              </Col>
              <Col className="so-align-items-left" sm="1">
                {" "}
                <FormLabel
                  className="hyperlinklabel"
                  onClick={(e) => this.lnkPOModule(e)}
                >
                  PO#
                </FormLabel>
                <Col>
                  <ShortCutMenuPopup
                    value={purchaseOrderReceiptData.purchaseOrderNumber}
                    menuItems={
                      <ul>
                        <li
                          className="shortcut-menu-item"
                          onClick={(e) => this.lnkPOModule(e)}
                        >
                          {" "}
                          PurchaseOrder Info{" "}
                        </li>
                      </ul>
                    }
                  />
                </Col>
              </Col>
              <Col sm="2">
                {" "}
                <InputTextbox
                  onChange={this.onPurchaseOrderChange}
                  ref={this.purchaseOrderRef}
                  readOnly={disableFormFields}
                  disabled={isDisabledFields}
                  name="purchaseOrderNumber"
                  placeholder="purchaseOrderNumber"
                  value={purchaseOrderReceiptData.purchaseOrderNumber}
                  lookupRequired={this.props.isDisableButtons}
                  lookupHandler={this.state.purchaseOrderLookupHandler}
                  enterKeyEventHandler={this.purchaseOrderEnterKeyEventHandler}
                  autoCompleteListData={
                    this.props.purchaseOrderPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayAutoCompletePurchaseOrderList
                  }
                  showAutoCompleteList={
                    this.props.isShowAutoCompletePurchaseOrderList
                  }
                  isMandatory={true}
                ></InputTextbox>
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel
                  className="hyperlinklabel"
                  onClick={(e) => this.lnkPOIntransitModule(e)}
                >
                  PurchaseInTransit#
                </FormLabel>{" "}
              </Col>
              <Col sm="2">
                {" "}
                <InputTextbox
                  onChange={this.poIntransitOnChange}
                  ref={this.shipViaRef}
                  placeholder="purchaseOrderInTransitNumber"
                  name="purchaseOrderInTransitNumber"
                  value={purchaseOrderReceiptData.purchaseOrderInTransitNumber}
                  lookupRequired={this.props.isShowInTransitLookup}
                  lookupHandler={this.props.purchaseInTransitLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.poIntransitEnterKeyEventHandler}
                  autoCompleteListData={
                    this.props.poIntransitPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayPOIntransitAutoCompleteList
                  }
                  showAutoCompleteList={
                    this.props.isShowAutoCompletePoIntransitList
                  }
                  readOnly={disableFormFields}
                  disabled={this.props.isDisablePoIntransit}
                />
              </Col>
              <Col sm="1">
                <FormLabel>ShipVia#</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.shipViaOnChange}
                  ref={this.shipViaRef}
                  placeholder="shipViaCode"
                  name="shipViaCode"
                  value={purchaseOrderReceiptData.shipViaCode}
                  lookupRequired={this.props.isDisableButtons}
                  lookupHandler={this.state.shipViaLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.shipViaEnterKeyEventHandler}
                  autoCompleteListData={
                    this.props.shipViaPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayShipViaAutoCompleteList}
                  showAutoCompleteList={
                    this.props.isShowAutoCompleteShipViaList
                  }
                  readOnly={disableFormFields}
                  disabled={isDisabledFields}
                />
              </Col>
            </Row>
            <Row>
              <Col sm="1">
                <FormLabel>Vendor</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="vendorCode"
                  type="text"
                  placeholder="Enter vendorCode"
                  value={purchaseOrderReceiptData.vendorCode}
                  disabled={true}
                />
              </Col>
              <Col sm="3">
                <InputTextbox
                  name="vendorName"
                  type="text"
                  placeholder="Enter vendorName"
                  value={purchaseOrderReceiptData.vendorName}
                  disabled={disableFormFields}
                />
              </Col>
              <Col sm="1">
                <FormLabel>Factory#</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="factoryCode"
                  type="text"
                  placeholder="Enter factoryCode"
                  value={purchaseOrderReceiptData.factoryCode}
                  onChange={this.onChange}
                  disabled={disableFormFields}
                />
              </Col>
              <Col sm="1">
                <FormLabel>Location#</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.locationOnChange}
                  ref={this.warehouseRef}
                  placeholder="LocationCode"
                  name="locationCode"
                  value={purchaseOrderReceiptData.locationCode}
                  lookupRequired={this.props.isDisableButtons}
                  lookupHandler={this.state.warehouseLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.locationEnterKeyEventHandler}
                  autoCompleteListData={
                    this.props.locationPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayLocationAutoCompleteList}
                  showAutoCompleteList={
                    this.props.isShowAutoCompleteLocationList
                  }
                  readOnly={disableFormFields}
                  disabled={isDisabledFields}
                  isMandatory={true}
                />
              </Col>
            </Row>
            <Row>
              <Col sm="1">
                <FormLabel>PackingSlip#</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="packingSlipNumber"
                  type="text"
                  placeholder="Enter packingSlipNumber"
                  value={purchaseOrderReceiptData.packingSlipNumber}
                  onChange={this.onChange}
                  disabled={disableFormFields}
                />
              </Col>
              <Col sm="1">
                <FormLabel>ShipmentTerm#</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.shipmentTermOnChange}
                  ref={this.shipmentTermRef}
                  placeholder="shipmentTermsCode"
                  name="shipmentTermsCode"
                  value={purchaseOrderReceiptData.shipmentTermsCode}
                  lookupRequired={this.props.isDisableButtons}
                  lookupHandler={this.state.shipmentTermLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.shipmentTermEnterKeyEventHandler}
                  autoCompleteListData={
                    this.props.shipmentTermPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayShipmentTermAutoCompleteList
                  }
                  showAutoCompleteList={
                    this.props.isShowAutoCompleteShipmentTermList
                  }
                  readOnly={disableFormFields}
                  disabled={isDisabledFields}
                />
              </Col>
              <Col sm="1">
                <FormLabel>FobCity#</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.fobCityOnChange}
                  ref={this.fobCityRef}
                  placeholder="fOBCity"
                  name="fOBCity"
                  value={purchaseOrderReceiptData.fOBCity}
                  lookupRequired={this.props.isDisableButtons}
                  lookupHandler={this.state.fobCityLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.fobCityEnterKeyEventHandler}
                  autoCompleteListData={
                    this.props.FobCityPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayFobCityAutoCompleteList}
                  showAutoCompleteList={
                    this.props.isShowAutoCompleteFobCityList
                  }
                  readOnly={disableFormFields}
                  disabled={isDisabledFields}
                />
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>Receipt Date</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <DatePickerComponent
                  name="receiptDate"
                  value={purchaseOrderReceiptData.receiptDate}
                  onChange={this.onChange}
                  disabled={disableFormFields}
                  isMandatory={true}
                />
              </Col>
              {/* <Col sm="1">
                <FormLabel>Customer#</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="customerCode"
                  value={purchaseOrderReceiptData.customerCode}
                  onChange={this.onChange}
                  disabled={true}
                />
              </Col> */}
            </Row>
            <Row>
              <Col sm="1">
                <FormLabel>ManufacturerLot</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="ManufacturerBatchNumber"
                  type="text"
                  value={purchaseOrderReceiptData.manufacturerBatchNumber}
                  onChange={this.onChange}
                  disabled={disableFormFields}
                />
              </Col>
              {/* <Col sm="1">
                <FormLabel>BillOfLading#</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="billOfLading"
                  type="text"
                  placeholder="Enter billOfLading"
                  value={purchaseOrderReceiptData.billOfLading}
                  onChange={this.onChange}
                  disabled={disableFormFields}
                />
              </Col> */}

              {is3PL && (
                <Col sm="1">
                  <FormLabel>Container#</FormLabel>{" "}
                </Col>
              )}
              {is3PL && (
                <Col sm="2">
                  <InputTextbox
                    name="containerNumber"
                    type="text"
                    value={purchaseOrderReceiptData.containerNumber}
                    onChange={this.onChange}
                    disabled={disableFormFields}
                  />
                </Col>
              )}
              {is3PL && (
                <Col sm="1">
                  <FormLabel>CustRef#</FormLabel>{" "}
                </Col>
              )}
              {is3PL && (
                <Col sm="2">
                  <InputTextbox
                    name="customerReferenceNumber"
                    type="text"
                    value={purchaseOrderReceiptData.customerReferenceNumber}
                    onChange={this.onChange}
                    disabled={disableFormFields}
                  />
                </Col>
              )}
            </Row>
            <Row>
              <Col sm="3">
                {this.props.isShowPORButton ? (
                  <Button
                    id="fabric_Add_Button"
                    className="enterFocus"
                    size="sm"
                    onClick={(e) => this.loadReceiptLines(e)}
                  >
                    Load Receipt Lines From PO
                  </Button>
                ) : null}
              </Col>
              <Col sm="1">
                <FormLabel>comments</FormLabel>{" "}
              </Col>
              <Col sm="2">
                <textarea
                  style={textAreaStyle}
                  className="form-control"
                  name="comments"
                  type="text"
                  placeholder="Enter comments"
                  onChange={this.onChange}
                  value={purchaseOrderReceiptData.comments}
                  disabled={disableFormFields}
                />
              </Col>
            </Row>
          </div>
          <div className="header_div">
            <div className="div_Custom_4">
              <div>
                <Table id="fabrics_tables_default">
                  <thead>
                    <tr>
                      <th>Line#</th>
                      <th>{is3PL ? "Item#" : "FabricStyle#"}</th>
                      <th>{is3PL ? "ItemName" : "FabricStyleName"}</th>
                      <th>Color#</th>
                      <th>UOM#</th>
                      <th>OrdQty</th>
                      <th>opnOrderQty</th>
                      <th>RcdToDT</th>
                      <th>ReceivedQty</th>
                      <th>InTransitQty</th>
                      <th>CurrentInTransitQty</th>
                      <th>Status</th>
                      <th></th>
                    </tr>
                  </thead>
                  {lines != null ? (
                    <tbody>
                      {lines.map((ln, index) => (
                        <tr key={index}>
                          <td className="hyperLinkText">
                            <Button
                              variant="secondry"
                              className="hyperLinkText"
                              onClick={(e) =>
                                this.editPurchaseOrderReceiptLine(
                                  e,
                                  ln.lineNumber,
                                  ln
                                )
                              }
                            >
                              {ln.lineNumber}
                            </Button>
                          </td>
                          <td>{ln.fabricStyleCode}</td>
                          <td>{ln.fabricStyleName}</td>
                          <td>{ln.colorCode}</td>
                          <td>{ln.uomCode}</td>
                          <td>{ln.purchaseOrderQuantity}</td>
                          <td>{ln.openOrderQuantity}</td>
                          <td>{ln.receivedQuantityToDate}</td>
                          <td>{ln.receivedQuantity}</td>
                          <td>{ln.inTransitQuantity}</td>
                          <td>{ln.openInTransistQuantity}</td>
                          <td>
                            {ModuleUtils.getPurchaseOrderReceiptLineStatusCaption(
                              ln.lineStatus
                            )}
                          </td>
                          <td>
                            {ln.lineStatus !=
                              LogicConstants.PURCHASEORDER_RECEIPT_LINE_CANCEL_STATUS && (
                              <Button
                                size="sm"
                                onClick={(e) =>
                                  this.deleteReceiptLine(e, ln.lineNumber, ln)
                                }
                                disabled={!this.props.isDisableButtons}
                              >
                                <DeleteIcon />
                              </Button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  ) : null}
                </Table>
                {lines.length != 0 ? null : (
                  <div className="no_Data">{"NO DATA"}</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
class PurchaeOrderReceiptLinePopUpForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
  }
  onLineChange = (e) => {
    this.props.onLineChange(e);
  };
  uploadExcelFile = (e) => {
    this.props.uploadExcelFile(e);
  };
  onRollLineUpdate = (e) => {
    if (e.detail == 1) this.props.addOrUpdatePurchaseOrderReceiptRollLine(e);
    // this.closeLinePopup();
  };
  clearRollLineDetails = (e) => {
    if (e.detail == 1) this.props.clearRollLineDetails();
  };
  onRollLineChange = (e) => {
    this.props.onRollLineChange(e);
  };
  editPurchaseOrderReceiptRollLine = (e, val, row) => {
    if (e.detail == 1) {
      this.props.editPurchaseOrderReceiptRollLine(val, row);
      this.showLinePopup();
    }
  };
  deleteReceiptRollLine = (e, rowData) => {
    if (e.detail == 1) this.props.deleteReceiptRollLine(rowData);
  };
  addNewRollLine = (e) => {
    if (e.detail == 1) {
      this.props.addNewRollLine(e);
      this.showLinePopup();
    }
  };
  showLinePopup = () => {
    this.props.showLinePopup();
  };
  closeLinePopup = () => {
    this.props.closeLinePopup();
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.props.closeRollLineCallBack(isShowPopup);
  };
  rollLineLocationOnChange = (e) => {
    this.props.rollLineLocationOnChange(e);
  };
  rollLineLocationEnterKeyEventHandler = (e) => {
    this.props.rollLineLocationEnterKeyEventHandler(e);
  };
  displayRollLineLocationAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayRollLineLocationAutoCompleteList(showAutoCompleteList);
  };
  onExcelClick = (e) => {
    if (e.detail == 1) {
      const input = document.getElementById("file-input");
      if (input) {
        input.click();
      }
    }
  };

  render() {
    let purchaseOrderReceiptData = this.props.purchaseOrderReceiptData;
    let purchaseOrderReceiptLineData = this.props.purchaseOrderReceiptLineData;
    let purchaseOrderReceiptRollLineData =
      this.props.purchaseOrderReceiptRollLineData;
    let disableFormFields = this.props.disableFormFields;
    let receiptRollLines = [];
    if (!isEmptyArray(this.props.poReceiptRollLinesList)) {
      receiptRollLines = this.props.poReceiptRollLinesList;
    }

    var poButtonLine = {
      alignContent: "center",
      width: "100%",
    };
    let is3PL = this.props.is3PL;
    return (
      <div className="header_div">
        {" "}
        <div>
          <Row>
            <Col sm="1">
              <FormLabel>Line#</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="lineNumber"
                type="text"
                placeholder="Enter LineNumber"
                value={purchaseOrderReceiptLineData.lineNumber}
                onChange={this.onLineChange}
                disabled={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>CompanyCode#</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="companyCode"
                type="text"
                placeholder="Enter companyCode"
                value={purchaseOrderReceiptLineData.companyCode}
                onChange={this.onLineChange}
                disabled={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>POReceipt#</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="purchaseOrderReceiptNumber"
                type="text"
                placeholder="Enter purchaseOrderReceiptNumber"
                value={purchaseOrderReceiptLineData.purchaseOrderReceiptNumber}
                onChange={this.onLineChange}
                disabled={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Location#</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="locationCode"
                type="text"
                placeholder="Enter companyCode"
                value={purchaseOrderReceiptData.locationCode}
                disabled={true}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>{is3PL ? "Item" : "FabricStyleCode"}</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="fabricStyleCode"
                type="text"
                placeholder="Enter fabricStyleCode"
                value={purchaseOrderReceiptLineData.fabricStyleCode}
                onChange={this.onLineChange}
                disabled={true}
              />
            </Col>
            <Col sm="3">
              <InputTextbox
                name="fabricStyleName"
                type="text"
                placeholder="Enter FabricStyleName"
                value={purchaseOrderReceiptLineData.fabricStyleName}
                onChange={this.onLineChange}
                disabled={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Color</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="colorCode"
                type="text"
                placeholder="Enter Color"
                value={purchaseOrderReceiptLineData.colorCode}
                onChange={this.onLineChange}
                disabled={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Width</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="widthCode"
                type="text"
                placeholder="Enter Width"
                value={purchaseOrderReceiptLineData.widthCode}
                onChange={this.onLineChange}
                disabled={true}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>OrderQty</FormLabel>
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                name={"purchaseOrderQuantity"}
                onChange={this.onLineChange}
                placeholder="Enter purchaseOrderQuantity"
                value={purchaseOrderReceiptLineData.purchaseOrderQuantity}
                className="qty_input text-right summary_input"
                decimalScale={2}
                disabled={true}
                onBlur={this.onBlur}
              />
            </Col>
            <Col sm="1">
              <FormLabel>OpenOrder Qty</FormLabel>
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                name={"openOrderQuantity"}
                placeholder="Enter openOrderQuantity"
                value={purchaseOrderReceiptLineData.openOrderQuantity}
                className="qty_input text-right summary_input"
                decimalScale={2}
                onBlur={this.onBlur}
                disabled={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Total Recd</FormLabel>
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                name={"receivedQuantity"}
                onChange={this.onLineChange}
                placeholder="Enter receivedQuantityToDate"
                value={purchaseOrderReceiptLineData.receivedQuantity}
                className="qty_input text-right summary_input"
                decimalScale={2}
                disabled={true}
                onBlur={this.onBlur}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Total Rolls</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                value={purchaseOrderReceiptLineData.totalRolls}
                className="qty_input text-right summary_input"
                disabled={true}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>UOM</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="uomCode"
                type="text"
                placeholder="Enter uomCode"
                value={purchaseOrderReceiptLineData.uomCode}
                onChange={this.onLineChange}
                disabled={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>RcdToDT</FormLabel>
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                name={"receivedQuantityToDate"}
                onChange={this.onLineChange}
                value={purchaseOrderReceiptLineData.receivedQuantityToDate}
                className="qty_input text-right summary_input"
                decimalScale={2}
                disabled={true}
                onBlur={this.onBlur}
              />
            </Col>
            <Col sm="1">
              <FormLabel>InTransitQty</FormLabel>
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                name={"openInTransistQuantity"}
                onChange={this.onLineChange}
                placeholder="Enter openInTransistQuantity"
                value={purchaseOrderReceiptLineData.openInTransistQuantity}
                className="text-right"
                decimalScale={2}
                disabled={true}
                onBlur={this.onBlur}
              />
            </Col>
            <Col sm="1">
              <FormLabel>Current InTransitQty</FormLabel>
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                name={"inTransitQuantity"}
                onChange={this.onLineChange}
                placeholder="Enter inTransitQuantity"
                value={purchaseOrderReceiptLineData.inTransitQuantity}
                className="text-right"
                decimalScale={2}
                disabled={true}
                onBlur={this.onBlur}
              />
            </Col>
          </Row>
          <div style={poButtonLine}>
            <Row>
              <Col sm="2">
                <FormLabel  className="label_head"> Received Line Rolls</FormLabel>
              </Col>
              </Row>
              <Row>
              <Col sm="2">
                <Button
                  className="header_buttons"
                  size="sm"
                  onClick={(e) => this.onExcelClick(e)}
                >
                  Load From Excel
                </Button>
                <input
                  type="file"
                  id="file-input"
                  style={{ display: "none" }}
                  onChange={this.uploadExcelFile}
                  accept=".doc,.docx,application/pdf,.xlsx, .xls, .csv,.txt"
                />
              </Col>
              <Col sm="3">
                {this.props.isDisableButtons && (
                  <Button
                    className="header_buttons"
                    onClick={(e) => this.addNewRollLine(e)}
                  >
                    Add Roll Line
                  </Button>
                )}
              </Col>
            </Row>
          </div>
          <div>
            <MultiViewPopup
              isModulePopup={false}
              isShowPopup={this.props.isShowLinePopup}
              closeOnEsc={false}
              popupLvlClass={"popupSizeLevel5"}
              closeAlertModalCallBack={this.closeAlertModalCallBack}
              title={"Roll LINE DETAIL"}
              closeOnDocumentClick={false}
              lineFunctionalityForm={this.lineFunctionalityForm}
              alertContainerBox={
                <AlertToolBox
                  alertMsgList={this.props.alertMessage}
                  alertErrorType={this.props.alertType}
                  isShowAlert={this.props.isShowPopupAlertlvl5}
                  hideAlertCallBack={this.props.hideAlertCallBacklvl5}
                />
              }
              headerButtonContainer={
                <div className="floatLeft">
                  <Button
                    className="header_buttons"
                    size="sm"
                    onClick={(e) => this.onRollLineUpdate(e)}
                    disabled={this.props.isDisableRollLine}
                  >
                    Add/Update
                  </Button>

                  <Button
                    className="header_buttons"
                    size="sm"
                    onClick={(e) => this.clearRollLineDetails(e)}
                    disabled={this.props.isDisableRollLine}
                  >
                    clear
                  </Button>
                </div>
              }
              content={
                <div>
                  <PurchaeOrderReceiptRollLinePopUpForm
                    disableFormFields={disableFormFields}
                    fabricStyle_List={this.props.fabricStyle_List}
                    purchaseOrderReceiptData={purchaseOrderReceiptData}
                    purchaseOrderReceiptLineData={purchaseOrderReceiptLineData}
                    purchaseOrderReceiptRollLineData={
                      purchaseOrderReceiptRollLineData
                    }
                    onLineChange={this.onRollLineChange}
                    showLinePopup={this.showLinePopup}
                    closeLinePopup={this.closeLinePopup}
                    isDisableRollLine={this.props.isDisableRollLine}
                    rollLineLocationOnChange={this.rollLineLocationOnChange}
                    rollLineLocationEnterKeyEventHandler={
                      this.rollLineLocationEnterKeyEventHandler
                    }
                    displayRollLineLocationAutoCompleteList={
                      this.displayRollLineLocationAutoCompleteList
                    }
                    rollLineLocationPageListForAutoCompleteList={
                      this.props.rollLineLocationPageListForAutoCompleteList
                    }
                    isShowAutoCompleteRolllineLocationList={
                      this.props.isShowAutoCompleteRolllineLocationList
                    }
                    wareHouses={this.props.wareHouses}
                    is3PL={this.props.is3PL}
                  />
                </div>
              }
            />
          </div>
          <div className="div_Custom_2">
            <Table id="fabrics_tables_default">
              <thead>
                <tr>
                  <th>Line#</th>
                  <th>Location#</th>
                  <th>Roll#</th>
                  <th>{this.props.is3PL ? "Inventory#" : "RollSKU#"}</th>
                  <th>ReceivedQty</th>
                  <th>InTransitQty</th>
                  <th>VENDOR LOT#</th>
                  <th>Box#</th>
                  <th>InvRcdQty#</th>
                  <th>InfoText</th>
                  <th>Bin Location#</th>
                </tr>
              </thead>
              {receiptRollLines != null ? (
                <tbody>
                  {receiptRollLines.map((roll, index) => (
                    <tr key={index}>
                      <td className="hyperLinkText">
                        <Button
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.editPurchaseOrderReceiptRollLine(
                              e,
                              roll.receiptRollLineNumber,
                              roll
                            )
                          }
                        >
                          {roll.receiptRollLineNumber}
                        </Button>
                      </td>
                      <td>{roll.locationCode}</td>
                      <td>{roll.rollNumber}</td>
                      <td>{roll.rollSkuNumber}</td>
                      <td>{roll.receivedQuantity}</td>
                      <td>{roll.inTransitQuantity}</td>
                      <td>{roll.vendorLotNumber}</td>
                      <td>{roll.boxNumber}</td>
                      <td>{roll.inventoryReceivedQuantity}</td>
                      <td>{roll.infoText}</td>
                      <td>{roll.aisleInfoText}</td>
                      <td>
                        <Button
                          size="sm"
                          onClick={(e) => this.deleteReceiptRollLine(e, roll)}
                          disabled={!this.props.isDisableButtons}
                        >
                          <DeleteIcon />
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : null}
            </Table>
            {receiptRollLines.length != 0 ? null : (
              <div className="no_Data">{"NO DATA"}</div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
class PurchaeOrderReceiptRollLinePopUpForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      warehouseLookupHandler: null,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let warehouseLookupHandler = new GenericAttributeLookupHandler(
      this.props.wareHouses,
      "Warehouse"
    );
    this.setState({ warehouseLookupHandler: warehouseLookupHandler });
  };
  onLineChange = (e) => {
    this.props.onLineChange(e);
  };
  onClick = (e) => {
    this.props.onClick(e);
  };
  rollLineLocationOnChange = (e) => {
    this.props.rollLineLocationOnChange(e);
  };
  rollLineLocationEnterKeyEventHandler = (e) => {
    this.props.rollLineLocationEnterKeyEventHandler(e);
  };
  displayRollLineLocationAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayRollLineLocationAutoCompleteList(showAutoCompleteList);
  };
  render() {
    let purchaseOrderReceiptRollLineData =
      this.props.purchaseOrderReceiptRollLineData;
    let disableFormFields = this.props.disableFormFields;
    let isDisableRollLine = this.props.isDisableRollLine;
    return (
      <div>
        <Row>
          <Col sm="2">
            <FormLabel>Line#</FormLabel>
          </Col>
          <Col sm="4">
            <InputTextbox
              name="lineNumber"
              type="text"
              placeholder="Enter LineNumber"
              value={purchaseOrderReceiptRollLineData.receiptRollLineNumber}
              disabled={true}
            />
          </Col>
          <Col sm="2">
            <FormLabel>Received Qty</FormLabel>
          </Col>
          <Col sm="4">
            <NumberFormatInputbox
              name={"receivedQuantity"}
              onChange={this.onLineChange}
              placeholder="Enter receivedQuantity"
              value={purchaseOrderReceiptRollLineData.receivedQuantity}
              className="text-right"
              decimalScale={2}
              disabled={disableFormFields}
              onBlur={this.onBlur}
              isMandatory={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="2">
            <FormLabel>Location#</FormLabel>
          </Col>
          <Col sm="4">
            <InputTextbox
              onChange={this.rollLineLocationOnChange}
              placeholder="LocationCode"
              name="locationCode"
              value={purchaseOrderReceiptRollLineData.locationCode}
              lookupRequired={true}
              lookupHandler={this.state.warehouseLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={this.rollLineLocationEnterKeyEventHandler}
              autoCompleteListData={
                this.props.rollLineLocationPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={
                this.displayRollLineLocationAutoCompleteList
              }
              showAutoCompleteList={
                this.props.isShowAutoCompleteRolllineLocationList
              }
              readOnly={disableFormFields}
              disabled={disableFormFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="2">
            <FormLabel>VENDOR LOT#</FormLabel>
          </Col>
          <Col sm="4">
            <InputTextbox
              name="vendorLotNumber"
              type="text"
              placeholder="Enter VENDOR LOT "
              value={purchaseOrderReceiptRollLineData.vendorLotNumber}
              disabled={disableFormFields}
              onChange={this.onLineChange}
              isMandatory={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="2">
            <FormLabel>Box#</FormLabel>
          </Col>
          <Col sm="4">
            <InputTextbox
              name="boxNumber"
              type="text"
              placeholder="Enter boxNumber"
              value={purchaseOrderReceiptRollLineData.boxNumber}
              disabled={disableFormFields}
              onChange={this.onLineChange}
            />
          </Col>
          <Col sm="2">
            <FormLabel>Roll#</FormLabel>
          </Col>
          <Col sm="4">
            <InputTextbox
              name="rollNumber"
              type="text"
              placeholder="Enter rollNumber"
              value={purchaseOrderReceiptRollLineData.rollNumber}
              onChange={this.onLineChange}
              disabled={disableFormFields}
              isMandatory={true}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="2">
            <FormLabel>
              {this.props.is3PL ? "Inventory#" : "RollSKU#"}
            </FormLabel>
          </Col>
          <Col sm="4">
            <InputTextbox
              name="rollSkuNumber"
              type="text"
              // placeholder="Enter rollSkuNumber"
              placeholder={
                this.props.is3PL ? "Enter Inventory#" : "Enter rollSKU#"
              }
              value={purchaseOrderReceiptRollLineData.rollSkuNumber}
              onChange={this.onLineChange}
              disabled={true}
            />
          </Col>
          <Col sm="2">
            <FormLabel>Intransit Qty</FormLabel>
          </Col>
          <Col sm="4">
            <NumberFormatInputbox
              name={"inTransitQuantity"}
              onChange={this.onLineChange}
              placeholder="Enter inTransitQuantity"
              value={purchaseOrderReceiptRollLineData.inTransitQuantity}
              className="text-right"
              decimalScale={2}
              disabled={true}
              onBlur={this.onBlur}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="2">
            <FormLabel>InvUOM</FormLabel>
          </Col>
          <Col sm="4">
            <InputTextbox
              name="inventoryUomCode"
              type="text"
              placeholder="Enter inventoryUomCode"
              value={purchaseOrderReceiptRollLineData.inventoryUomCode}
              onChange={this.onLineChange}
              disabled={disableFormFields}
            />
          </Col>
          <Col sm="2">
            <FormLabel>Inv Rcd Qty</FormLabel>
          </Col>
          <Col sm="4">
            <NumberFormatInputbox
              name={"inventoryReceivedQuantity"}
              onChange={this.onLineChange}
              placeholder="Enter inventoryReceivedQuantity"
              value={purchaseOrderReceiptRollLineData.inventoryReceivedQuantity}
              className="qty_input text-right summary_input"
              decimalScale={2}
              disabled={true}
              onBlur={this.onBlur}
            />
          </Col>
        </Row>
        <Row>
          <Col sm="2">
            <FormLabel>InfoText</FormLabel>
          </Col>
          <Col sm="4">
            <InputTextbox
              name="infoText"
              type="text"
              placeholder="Enter infoText"
              value={purchaseOrderReceiptRollLineData.infoText}
              onChange={this.onLineChange}
              disabled={disableFormFields}
            />
          </Col>
          <Col sm="2">
            <FormLabel>Aisle InfoText </FormLabel>
          </Col>
          <Col sm="4">
            <InputTextbox
              name="aisleInfoText"
              type="text"
              placeholder="Enter aisleInfoText"
              value={purchaseOrderReceiptRollLineData.aisleInfoText}
              onChange={this.onLineChange}
              disabled={disableFormFields}
            />
          </Col>
          {/* <Col sm="2">
            <FormLabel>Bin Loc#</FormLabel>
          </Col>
          <Col sm="4">
            <InputTextbox
              name="aisleInfoText"
              type="text"
              placeholder="Enter aisleInfoText"
              value={purchaseOrderReceiptRollLineData.aisleInfoText}
              onChange={this.onLineChange}
              disabled={disableFormFields}
            />
          </Col> */}
        </Row>
      </div>
    );
  }
}
class PurchaseOrderReceiptHistoryDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      //
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
  }
  DateGridColumnStatusDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition().setDetails("Date", "createdDate")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "OrderAmount#",
        "totalOrderAmount"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Status",
        "previousStatus",
        0,
        false,
        null,
        false,
        null,
        false,
        false,
        true,
        ModuleUtils.getPurchaseOrderReceiptStatusCaption
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "PreviousStatus",
        "currentStatus",
        0,
        false,
        null,
        false,
        null,
        false,
        false,
        true,
        ModuleUtils.getPurchaseOrderReceiptStatusCaption
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("DoneBy", "createdBy")
    );
    return columnList;
  };
  DateGridColumnChangeHistoryDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition().setDetails("Date", "updatedDate")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("UpdatedBy#", "updatedBy")
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Change", "description")
    );
    return columnList;
  };
  render() {
    let purchaseOrderReceiptData = this.props.purchaseOrderReceiptData;
    let statusTracks = purchaseOrderReceiptData.statusTracks;
    if (!statusTracks) {
      statusTracks = new Array();
    }
    let changeHistoryTracks = purchaseOrderReceiptData.changeHistoryTracks;
    if (!changeHistoryTracks) {
      changeHistoryTracks = new Array();
    }
    var styles = {
      header: {
        style: {
          minHeight: "0px",
        },
      },
      table: {
        style: {
          minHeight: "300px",
          maxHeight: "300px",
        },
      },
    };
    return (
      <div>
        <div className="header_div">
          <div className="div_Custom_3">
            <FormLabel>Status History</FormLabel>
            <DataGrid
              styles={styles}
              columnsList={this.DateGridColumnStatusDefinitions()}
              dataList={statusTracks}
              isLoading={false}
            />
          </div>
          <div className="div_Custom_3">
            <FormLabel>Header Change History</FormLabel>
            <DataGrid
              styles={styles}
              columnsList={this.DateGridColumnChangeHistoryDefinitions()}
              dataList={changeHistoryTracks}
              isLoading={false}
            />
          </div>
        </div>
      </div>
    );
  }
}
function PurchaseOrderReceiptModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div id="app_container"></div>
      <PurchaseOrderReceiptList {...props} name="" /> <br />
    </div>
  );
}

export default PurchaseOrderReceiptModule;
